<script setup>
import { computed, ref, inject, onMounted } from "vue";
import {
    mdiEye, mdiTrashCan, mdiPencil, mdiCheckCircle, mdiCloseCircle, mdiFileTableOutline, mdiFilePdfBox, mdiPrinter, mdiMenu, mdiFormatListCheckbox, mdiContentSave,
    mdiPlusCircle, mdiDownload, mdiSearchWeb, mdiMagnify, mdiBroom, mdiGraphql, mdiFileDocument, mdiEmailArrowRight, mdiWhatsapp, mdiPhoneOutgoing, mdiCashPlus, mdiDotsVertical, mdiDotsHorizontal, mdiCheckBold
} from "@mdi/js";// LRR https://materialdesignicons.com/
import CardBoxModal from "@/Components/CardBoxModal.vue";
import CardBoxModalFrame from "@/Components/CardBoxModalFrame.vue";
import TableCheckboxCell from "@/Components/TableCheckboxCell.vue";
import BaseLevel from "@/Components/BaseLevel.vue";
import BaseButtons from "@/Components/BaseButtons.vue";
import BaseButton from "@/Components/BaseButton.vue";
import UserAvatar from "@/Components/UserAvatar.vue";
import { Inertia } from '@inertiajs/inertia';
import { Link } from '@inertiajs/inertia-vue3';
import { read, utils, writeFileXLSX } from 'xlsx';
import BaseIcon from "@/Components/BaseIcon.vue";
import IconRounded from "@/Components/IconRounded.vue";
import pdfMake, { PropertyDescriptor } from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import BreezeInput from '@/Components/Input.vue';
import { dateFormat } from "vue-cal/dist/i18n/en.cjs";
import constanteApi from "@/conf-global.js";
import NotificationAlert from "@/Components/NotificationAlert.vue";
import BreezeDropdown from '@/Components/Dropdown.vue';
import BreezeDropdownLink from '@/Components/DropdownLink.vue';
import VueSelect from "vue3-select-component";

// Detectar si es mobile o pc desde ancho de pantalla
//import { useDeviceDetection } from '../Common/useDeviceDetection.js';
//const { isMobile } = useDeviceDetection()

const mainStore = defineProps({
    data: Array,
    checkable: Boolean,
    massDelete: Boolean,
    updateable: Boolean,
    visualable: Boolean,
    canView: {
        type: Boolean,
        default: true
    },
    canDownload: {
        type: Boolean,
        default: true
    },
    isCanActive: Boolean,
    deleteable: Boolean,
    exporteable: Boolean,
    fields: Array,
    ruta: String,
    modulo: String,
    modulos: String,
    noSearch: Boolean,
    showIndex: Boolean,
    numberItems: {
        type: Number,
        default: 25
    },
    noPaginate: Boolean,
    showTotales: Boolean,
    searchAdvance: Boolean,
    changeOption1: Boolean,
    changeSelect1: Boolean,
    changeSelect2: Boolean,
    changeSelect3: Boolean,
    changeSelect4: Boolean,
    titleSelect1: String,
    titleSelect2: String,
    titleSelect3: String,
    titleSelect4: String,
    select1: Object,// <-- Muestra waringn si lo paso como Array, llega como un sólo objeto
    select2: Object,
    select3: Object,
    select4: Object,
    originId: Number,
    originType: String,
    printLine: Boolean,
    titleExport: String,
    labelprint1: String,
    isSearchYear: Boolean,
    debugInertia: Boolean,
    searchdefault: String,
    searchfocus: Boolean,
    userParam: Object,
    optionsbutton: Boolean,
    vueselectmassaction: Boolean
});

// Llamar constantes
const helpers = inject('helpers');
const constGlobal = helpers.getConstantes()

//console.log('Device: ')
//console.log(isMobile.value)

onMounted(() => {
    //getConst()
    //getConst().then(console.log).catch(console.error)
    //console.log('global toast property: ', this.$confGlobal);
})

const loading = ref(false)
const searchField = ref(mainStore.searchdefault);
const searchVal = ref('');
//const storeData = ref(mainStore.data);
const storeData = computed(() => mainStore.data);
let titleExport = mainStore.titleExport

// Filtro avanzado
const searchFieldCol = ref({});
const campos = mainStore.fields || []
campos.forEach((field) => {
    searchFieldCol.value[field.col] = null
    searchFieldCol.value['existecols'] = 1 // <-- Para detectar qeu hay columnas
    if (typeof field.default_val !== 'undefined') { // <-- valores por default
        searchFieldCol.value[field.col] = field.default_val
        //console.log('default col: ' + field.default_val)
    }

});
//console.log(searchFieldCol.value)
const isSearchAdvanced = ref(false)
const dataList = ref(null)
const valueReplace = ref([])
const canPrint = ref(false)
//const contactCel = ref('')
//const contactEmail = ref('')

// orden de pago
const showDownloadTxt = ref(false)
const formatTxt = ref(1)
let tipoTxt = ''
let rucEntity = ''
let labelEntity = ''
let txtFechaBloqueo = ''
let integration_account_number = ''
let integration_code_service = ''
let integration_concept_code = ''
let integration_concept_description = ''
let integration_abono_account = ''
let integration_name_file = ''
let integration_indicador_ca = ''
let integration_pago_parcial = ''
var debugInertia = 0

const listarData = () => {

    // Con Axios
    let url = '/' + mainStore.ruta + '/list';// Una ruta post para enviar el arreglo
    if (mainStore.originType) {
        let url = '';
        let origintype = mainStore.originType;
        if (origintype == 'classroom' && mainStore.originId) {
            url = '/students/classroom?id_classroom=' + mainStore.originId;// /students/classroom'+'?id_classroom='+id_classroom
        } else if (origintype && origintype.includes('file_document_', 0)) { // <-- Pestaña Documentos
            url = '/document/' + mainStore.originType + '?src_object_id=' + mainStore.originId;
        } else if (origintype && origintype.includes('file_', 0)) { // <-- Otros files como file_guideforcourse
            url = '/document/' + mainStore.originType + '?consulta=1'; // <-- Consulta es para identeificar que se llama desde aquí
        }

        loading.value = true;
        axios.get(url).then(function (response) {
            let respuesta = response.data;

            dataList.value = respuesta.datalist;
            //isSearchAdvanced.value = true
            console.log('Listado de origin');
            //console.log(dataList.value);
            //Inertia.reload({ only: ['studens']})
        }).catch(function (error) {
            console.log(error);
        });
        loading.value = false;
    } else { // <-- Con filtros avanzados
        //axios.get(url).then(function (response) {
        loading.value = true;
        axios.post(url, searchFieldCol.value).then((response) => {
            let respuesta = response.data;
            if (mainStore.modulo == 'estudiante') {
                dataList.value = respuesta.students;
                //canPrint.value = true// <-- Para la libreta de notas
            } else if (mainStore.modulo == 'diario') {
                dataList.value = respuesta.diarios;
            } else {
                dataList.value = respuesta.datalist;
                if (mainStore.modulo == 'admisionpuntaje') {
                    valueReplace.value = respuesta.valuereplace
                    canPrint.value = respuesta.canPrint
                    titleExport = respuesta.titleExport
                    console.log(valueReplace.value)
                } else if (mainStore.modulo == 'payementOrder') {
                    showDownloadTxt.value = respuesta.showDownloadTxt;
                    tipoTxt = respuesta.tipoTxt;
                    searchFieldCol.value['tipoTxt'] = respuesta.tipoTxt
                    rucEntity = respuesta.rucEntity;
                    labelEntity = respuesta.labelEntity;
                    txtFechaBloqueo = respuesta.txtFechaBloqueo;
                    searchFieldCol.value['formatTxt'] = respuesta.formatTxt
                    integration_account_number = respuesta.integration_account_number
                    integration_code_service = respuesta.integration_code_service
                    integration_concept_code = respuesta.integration_concept_code
                    integration_concept_description = respuesta.integration_concept_description
                    integration_abono_account = respuesta.integration_abono_account
                    integration_name_file = respuesta.integration_name_file
                    integration_indicador_ca = respuesta.integration_indicador_ca
                    integration_pago_parcial = respuesta.integration_pago_parcial
                    //formatTxt.value = respuesta.formatTxt;
                    //debugInertia = respuesta.debugInertia;
                    //let contactInformation = respuesta.contactInformation;
                    //contactCel.value = 
                    //contactEmail.value =
                }
            }

            //isSearchAdvanced.value = true
            console.log('filtrado');
            console.log(searchFieldCol.value)
            //console.log(dataList.value);
            //Inertia.reload({ only: ['studens']})
        }).catch(function (error) {
            console.log(error);
        });
        loading.value = false;
    }



    // Con Inertia
    /* let ruta = mainStore.ruta + '-list-filter'
    Inertia.post(route(ruta, searchFieldCol.value))
    Inertia.reload({ only: ['data']}) */
}

const cleanAdvancedFilter = () => {
    campos.forEach((field) => {
        searchFieldCol.value[field.col] = null
    });
    listarData()
}
/* if (isSearchAdvanced.value) {
  console.log(dataList.value)
  storeData.value.value=dataList.value
} */
// Fin de filtro avanzado

// - LRR const getItemsByFilter = (field, search) => storeData.value.filter( data => data[field] === search)
// - LRR const getItemsByFilter = (field, search) => storeData.value.filter( data => data[field].includes(search))
//const getItemsByFilterAll = (search) => storeData.value.filter( data => data.map.toLowerCase().includes(search.toLowerCase()) )

const getItemsByFilter = (field, search) => storeData.value.filter(data => data[field] ? data[field].toLowerCase().includes(search.toLowerCase()) : '')
const getItemsByFilterNumber = (field, search) => storeData.value.filter(data => data[field] == search)

const getItemsByFilter2 = (field, search) => dataList.value.filter(data => data[field] ? data[field].toLowerCase().includes(search.toLowerCase()) : '')
const getItemsByFilterNumber2 = (field, search) => dataList.value.filter(data => data[field] == search)

const items = computed(() => {

    //mainStore.searchAdvance
    if (1 == 2) {
        console.log(storeData.value)
        const dataFilter = storeData.value.filter(data => {
            //if (data['apellidos'].includes(searchFieldCol.value['apellidos'])) return true

            //return Object.keys(searchFieldCol.value).every(key => {
            //return searchFieldCol.value[key] === data[key]
            //})

            let i = 0;
            let result = []
            for (var key in searchFieldCol.value) {
                if (typeof searchFieldCol.value[key] == 'number' || searchFieldCol.value[key]) {
                    if (isNaN(searchFieldCol.value[key])) {
                        console.log('text ')
                        result[i] = data[key] && searchFieldCol.value[key] && data[key].toLowerCase().includes(searchFieldCol.value[key].toLowerCase())

                    } else {
                        console.log('number ')
                        result[i] = data[key] === searchFieldCol.value[key]

                    }
                } else {
                    result[i] = false
                }

                i++
            }

            return (result[0] ? result[0] : '') && (result[1] ? result[1] : '')

            //return (result[0]?? false)
            //&& (result[1] ?? false)
            //&& (result[2] ?? false)
            //&& (result[3] ?? false)
            //&& (result[4] ?? false)
            // && (result[5] ?? false)
            //&& (result[6] ?? false)
            // && (result[7] ?? false)
            //&& (result[8] ?? false)
            //&& (result[9] ?? false)
            //&& (result[10] ?? false)
        })
        //console.log(dataFilter)
        if (dataFilter.length) {
            return dataFilter
        } else {
            return storeData.value
        }

    } else {
        // Método de búsqueda por un sólo campo
        if (searchField.value && (searchVal.value || searchVal.value === 0)) {// <-- texto o el valor pueda ser cero en booleanos

            // Estandaríazar por tipo de campo
            let col = mainStore.fields.map(c => c.col).indexOf(searchField.value)
            if (col >= 0 && (mainStore.fields[col].type == 'foraign' || mainStore.fields[col].type == 'boolean' || mainStore.fields[col].type == 'status' || mainStore.fields[col].type == 'number')) {
                if (dataList.value) {
                    return getItemsByFilterNumber2(searchField.value, searchVal.value)
                } else {
                    return getItemsByFilterNumber(searchField.value, searchVal.value)
                }

            } else {
                if (dataList.value) {
                    return getItemsByFilter2(searchField.value, searchVal.value)
                } else {
                    return getItemsByFilter(searchField.value, searchVal.value)
                }

            }

        } else {
            if (dataList.value) {
                return dataList.value
            } else {
                return storeData.value
            }

        }
    }


});

//const items = computed(() => storeData.value);

const isModalActive = ref(false);
const isModalFullActive = ref(false);
const modalFullSrc = ref('');

const isModalDangerActive = ref(false);

//mainStore.numberItems
const perPage = ref(mainStore.numberItems);

const currentPage = ref(0);

const checkedRows = ref([]);

const itemsPaginated = computed(() =>
    items.value.slice(
        perPage.value * currentPage.value,
        perPage.value * (currentPage.value + 1)
    )
);

// LRR
//console.log(itemsPaginated)
const isShowAllPages = ref(false)

const numPages = computed(() => Math.ceil(items.value.length / perPage.value));

//const currentPageSearch = ref(currentPage.value + 1);// LRR
const currentPageHuman = computed(() => currentPage.value + 1);
//const currentPageHuman = computed(() => currentPageSearch.value);// + LRR 
const pagesList = computed(() => {
    const pagesList = [];

    for (let i = 0; i < numPages.value; i++) {
        pagesList.push(i);
    }

    return pagesList;
});
const remove = (arr, cb) => {
    const newArr = [];

    arr.forEach((item) => {
        if (!cb(item)) {
            newArr.push(item);
        }
    });

    return newArr;
};
const checked = (isChecked, client) => {
    if (isChecked) {
        checkedRows.value.push(client);
    } else {
        checkedRows.value = remove(
            checkedRows.value,
            (row) => row.id === client.id
        );
    }
};

// Totales Usar mejor un set
//const sumaTotalTTC = ref(0)

// LRR

const selectRows = ref([])
const allCheckBox = ref(false)
const countChecked = ref(0)
const massaction = ref('')
const id_select1 = ref(0)
const id_select2 = ref(0)
const id_select3 = ref(0)
const id_select4 = ref(0)

const cleanMassAction = () => {
    massaction.value = ''
    selectRows.value = []
    allCheckBox.value = false
    countChecked.value = 0
    id_select1.value = 0
    id_select2.value = 0
    id_select3.value = 0
    id_select4.value = 0
    massiveFieldValue.value = ''
    massiveFieldValue2.value = ''
    massiveFieldValue3.value = ''
}

/* console.log(selectRows[1])
console.log(selectRows[2])
console.log(allCheckBox) */

const countCheckedSingle = () => {
    countChecked.value = 0// <-- Reiniciar contador
    for (var i = 0; i < selectRows.value.length; i++) {

        if (selectRows.value[i + 1] == true) {
            countChecked.value++
        }
    }
}

const changeAllCheckBox = () => {
    //console.log(itemsPaginated.value.length)
    countChecked.value = 0// <-- Reiniciar contador
    for (var i = 0; i < itemsPaginated.value.length; i++) {
        selectRows.value[i + 1] = !selectRows.value[i + 1]
        if (selectRows.value[i + 1] == true) {
            countChecked.value++
        }
    }
}

// Agregar reload <-- Con esto recarga el listado origen en lugar de usar la función listarData <-- Cambiar lo demás a futuro
const emit = defineEmits(["update:modelValue", "cancel", "confirm", "emitPromedios", "reload"]);

const emisiones = (mode, id) => {
    //value.value = false;// LRR creo que es un valor v-model cuando se use
    emit(mode, id);// Segundo parámetro es el evento
    console.log('tablemodeemit')
}

const showPromedios = (id) => emisiones("emitPromedios", id);

const massiveFieldValue = ref('')
const massiveFieldValue2 = ref('')
const massiveFieldValue3 = ref('')

const massAction = async (action) => {
    //let ruta = mainStore.ruta + '-massaction'
    //let url = route(ruta);
    let ruta = '/' + mainStore.ruta + '/massaction';
    var arrayitemschecks = []

    for (var i = 0; i < itemsPaginated.value.length; i++) {
        if (selectRows.value[i + 1] == true) {
            //arrayitemschecks[i] = itemsPaginated.value[i].id
            if (mainStore.modulo == 'estudiante') {// <-- capturar selecciones masivas
                arrayitemschecks[i] = itemsPaginated.value[i].id_person
            } else {
                arrayitemschecks[i] = itemsPaginated.value[i].id
            }

        }
    }

    // Eliminar nulos -> Compmatibilidad de uso de Axios en lugar de Inertia
    var arrayitems = arrayitemschecks.filter(function (el) {
        return el != null;
    });

    //if (mainStore.originId && mainStore.originType == 'classroom') {


    /*  Inertia.put(route(ruta, {
         //'id' : id
         'action' : action,
         'cr' : arrayitems,// checkedRows <-- minimizar URI
         'modulo': mainStore.modulo, //<-- Llevar el modulo al controlador
         'origin_type' : mainStore.originType,
         'id_select1': id_select1.value
         
       }
     )) */

    // FIX 240312 <-- Inertia post and put to Axios
    let formMassAction = {
        'action': action,
        'cr': arrayitems,// checkedRows <-- Minimizar URI
        'modulo': mainStore.modulo, //<-- Llevar el modulo al controlador
        'origin_type': mainStore.originType,
        'id_select1': id_select1.value,
        'id_select2': id_select2.value,
        'id_select3': id_select3.value,
        'id_select4': id_select4.value,
        'field_value': massiveFieldValue.value,
        'field_value2': massiveFieldValue2.value,
        'field_value3': massiveFieldValue3.value
    };

    loading.value = true;
    await axios.put(ruta, formMassAction).then((response) => {
        let respuesta = response.data;
        if (respuesta.success) {
            if (respuesta.warning) {
                showAlert(respuesta.message, 'warning', 16)
            } else {
                showAlert(respuesta.message, 'success', 8)
            }
            listarData()
            cleanMassAction()
            cleanVal()
            emit('reload') // SI existe reload emitir una acción

        } else {
            showAlert(respuesta.message, 'danger', 64)
        }
        console.log('Registros masivos cambiados'); // Acciones masivas
        //console.log(respuesta);
    }).catch((error) => {
        console.log(error);
        console.log('Registros masivos no cambiados');
    });
    loading.value = false;

    /* Inertia.put(route(ruta, {
        //'id' : id
        'action' : action,
        'cr' : arrayitems,// checkedRows <-- Minimizar URI
        'modulo': mainStore.modulo, //<-- Llevar el modulo al controlador
        'origin_type' : mainStore.originType,
        'id_select1': id_select1.value,
        'id_select2': id_select2.value,
        'id_select3': id_select3.value,
        'id_select4': id_select4.value,
        'field_value': massiveFieldValue.value,
        'field_value2': massiveFieldValue2.value,
        'field_value3': massiveFieldValue3.value
      }
    ))
    console.log(arrayitems) */


    cleanMassAction()
    //console.log(arrayitems)
}

// LRR Ordenar por cada columna
const orderSentido = ref(false)// por defecto ASC
const orderByCol = (col) => {
    if (orderSentido.value == false) {
        items.value.sort((a, b) => (a[col] > b[col]) ? 1 : ((b[col] > a[col]) ? -1 : 0))
        //items.value.sort((a,b) => a[col] - b[col])
    } else {
        items.value.sort((a, b) => (a[col] < b[col]) ? 1 : ((b[col] < a[col]) ? -1 : 0))
        //items.value.sort((a,b) => b[col] - a[col])
    }
    orderSentido.value = !orderSentido.value
}

const rowID = ref(0);
const rowAction = ref('action');
const titleModal = ref('')
const isErrorForm = ref(false)

const initModal = (id, action) => {
    isErrorForm.value = false
    rowAction.value = action
    rowID.value = id;
    isModalDangerActive.value = true
}



const isConfirm = async () => {

    // Mass Action
    if (massaction.value != '') {
        massAction(massaction.value)
    } else if (rowAction.value != '') { // <-- Acción Row  - eliminar por ejemplo, la que viene con el método
        //let ruta = '/' + mainStore.ruta + '/massaction';
        let ruta = mainStore.ruta + '-' + rowAction.value;
        //let ruta = 'file-eliminar'

        let id_row = rowID.value
        let dataparam = {
            'id': id_row
        }
        loading.value = true;
        await axios.post(route(ruta), dataparam).then((response) => {
            if (response.data.error) {
                showAlert(response.data.message, 'danger', 64)
            } else if (response.data.success) {
                if (response.data.warning) {
                    showAlert(response.data.message, 'warning', 16)
                } else {
                    showAlert(response.data.message, 'success', 8)
                }

                rowID.value = 0
                rowAction.value = ''
                //listarData()
                emit('reload')
            }
            //console.log(response.data)
        }).catch((error) => {
            console.log(error);
        });
        loading.value = false;
    }
}

const selectCriterio = ref('p.nombres');
const buscarCriterio = ref('');


const listar = (criterio, buscar) => {
    // + '?criterio=' + criterio + '&buscar=' + buscar
    let ruta = mainStore.ruta + '-list'
    Inertia.get(route(ruta, {
        'criterio': criterio,
        'buscar': buscar
    }
    ))

    buscarCriterio.value = ''
    //}
}

const isCancel = () => {
    cleanVal()
}
const cleanVal = () => {
    rowID.value = 0;
    rowAction.value = ''
    modalFullSrc.value = ''
    //massaction.value = ''

    selectRows.value = []
    allCheckBox.value = false
    countChecked.value = 0
    massaction.value = ''
    id_select1.value = 0
    id_select2.value = 0
    id_select3.value = 0
    id_select4.value = 0
}

/**
 * LRR
 * Exportar
 */
// título <-- Se toma de una variable let

// Get Data
const modulos = mainStore.modulos
//console.log(modulos)

// Descarga txt
const nowDate = new Date()
const anioActual = nowDate.getFullYear()
const anioActualRef = ref(anioActual)
//const anioActualSearch = ref('')
const mesActualPrev = nowDate.getMonth() + 1
const mesActual = mesActualPrev < 10 ? '0' + mesActualPrev.toString() : mesActualPrev.toString()
const diaActual = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate()
const fechaHoy = diaActual.toString() + '/' + mesActual + '/' + anioActual.toString()// <-- Probar el inicio del siguiente mes
const fecha_hoy_8C = anioActual.toString() + mesActual + diaActual.toString()
//const filenameExport = 'ImportTxt_'+rucEntity+'_'+tipoTxt+'_'+fecha_hoy_8C

// UPD 230604 - Se agrega async para usar el await de construir la base 64 de la imagen
const exportFile = async (ext) => {
    if (ext == 'xlsx') {
        // Excel DOC https://docs.sheetjs.com/docs/csf/features/
        const expItems = items.value;
        //const expFields = mainStore.fields;
        const expFields = mainStore.fields.filter(col => !col.noexport);// <-- Quitar columnas si noexport es true

        const dataExport = ref([])
        expItems.forEach((client, index) => {
            //Definir que el arreglo index también será un arreglo
            // y así se crea el arreglo multidimensional Ref https://stackoverflow.com/questions/16300036/multidimensional-array-in-javascript-cannot-set-property-0-of-undefined
            dataExport.value[index] = []
            expFields.forEach((field, index2) => {
                //if (field.type == 'boolean' || field.type == 'foraign') {
                if (field.type == 'text' || field.type == 'date' || field.type == 'month' || field.type == 'number' || field.type == 'mobile_phone') {
                    //dataExport.value[index][field.name] = field.replace[client[field.col]]
                    dataExport.value[index][field.name] = client[field.col]
                } else if (field.type == 'replacefromid') {
                    //dataExport[index][index2] = field.replace[client[field.col]]
                    // Si hay un celda n definida hay error, por eso se agrega el -
                    dataExport.value[index][field.name] = valueReplace.value[client.id] ? valueReplace.value[client.id] : '-'
                } else {
                    //dataExport.value[index][field.name] = client[field.col]
                    dataExport.value[index][field.name] = field.replace[client[field.col]]
                }

            })
        })
        //console.log(items.value);
        //console.log(dataExport.value);

        const ws = utils.json_to_sheet(dataExport.value)

        // Ancho de la primera columna
        /*
        var wscols = [
            {wch: 20}, // "characters"
            //{wpx: 50}, // "pixels"
            //,
            //{hidden: true} // hide column
        ];
        ws['!cols'] = wscols;
        */

        const wb = utils.book_new()
        utils.book_append_sheet(wb, ws, 'Data')
        writeFileXLSX(wb, modulos + 'Report.xlsx')
    } else if (ext == 'pdf') {
        // PDF DOC https://pdfmake.github.io/docs/0.1/getting-started/client-side/
        // https://pdfmake.github.io/docs/0.1/document-definition-object/tables/
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
        const expItems = items.value;
        const expFields = mainStore.fields.filter(col => !col.noexport);// <-- Quitar columnas si noexport es true
        //console.log(expFields)

        // Si se usaba ref había error pues no era un array explícito
        // Se declara la primera fila para los títulos
        let dataExport = []
        dataExport[0] = []

        // Mostrar numeración
        let factorCol = 0
        if (mainStore.showIndex) {
            factorCol = 1
            dataExport[0][0] = '#'
        }

        expFields.forEach((field, index) => {
            dataExport[0][index + factorCol] = field.name
        })

        var totales = { 'ttc': 0 }
        let lastLine = 0
        //dataExport.value[0] = expFields.name
        expItems.forEach((client, index) => {
            //Definir que el arreglo index también será un arreglo
            // y así se crea el arreglo multidimensional Ref https://stackoverflow.com/questions/16300036/multidimensional-array-in-javascript-cannot-set-property-0-of-undefined

            // Todos los índices serán más 1 pues el cero lo tomó el título
            dataExport[index + 1] = []

            // Mostrar número de orden
            if (factorCol) {
                dataExport[index + 1][0] = index + 1
            }

            expFields.forEach((field, index2) => {

                //if (index == 0) {
                //if (index == 0) dataExport[index][index2] = field.name
                //} else {
                //if (field.type == 'boolean' || field.type == 'foraign') {
                if (field.type == 'text' || field.type == 'date' || field.type == 'month' || field.type == 'number' || field.type == 'mobile_phone') {
                    //dataExport[index][index2] = field.replace[client[field.col]]
                    // Si hay un celda n definida hay error, por eso se agrega el -
                    dataExport[index + 1][index2 + factorCol] = client[field.col] ? client[field.col] : '-'
                    if (mainStore.showTotales && field.type == 'number' && client[field.col] && field.col == 'total_ttc') totales.ttc += parseFloat(client[field.col])
                } else if (field.type == 'replacefromid') {
                    //dataExport[index][index2] = field.replace[client[field.col]]
                    // Si hay un celda n definida hay error, por eso se agrega el -
                    dataExport[index + 1][index2 + factorCol] = valueReplace.value[client.id] ? valueReplace.value[client.id] : '-'
                } else {
                    //dataExport[index][index2] = client[field.col]
                    dataExport[index + 1][index2 + factorCol] = field.replace[client[field.col]] ? field.replace[client[field.col]] : '-'
                }
                //}

            })

        })

        // Totales
        lastLine = dataExport.length
        if (mainStore.showTotales) {
            dataExport[lastLine] = []// <-- Lo tengo que declarar este arreglo antes si no estará como no defined
            expFields.forEach((field, index3) => {
                if (field.type == 'number' && field.col == 'total_ttc') {
                    dataExport[lastLine][index3 + factorCol] = totales.ttc
                } else {
                    dataExport[lastLine][index3 + factorCol] = '\t'// <-- Espacio en blanco
                }
            })
        }

        //console.log(items.value);
        //console.log(dataExport);

        let colWith = []

        // Si hay index declararlo
        if (factorCol) {
            colWith[0] = 'auto'
        }

        for (let i = 0; i < expFields.length; i++) {
            colWith[i + factorCol] = 'auto'
        }
        //console.log(colWith);
        let pageOrientation = 'portrait';
        if (colWith.length > 8 || mainStore.modulo == 'cobranzas') {// <-- Determina la orientación la cantidad de columnas
            pageOrientation = 'landscape';
        }
        var docDefinition = {
            // a string or { width: number, height: number }
            pageSize: (colWith.length > 14 ? 'A3' : 'A4'),

            // by default we use portrait, you can change it to landscape if you wish
            //pageOrientation: 'landscape',
            pageOrientation: pageOrientation,

            // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
            //pageMargins: [ 40, 60, 40, 60 ],
            pageMargins: [40, 80, 40, 50],

            // Antiguo Header
            //header: [{ text: 'Total '+modulos+' : '+expItems.length, margin: [40, 10, 0, 0]}],

            // New header with image
            header: {
                // margin: [left, top, right, bottom]
                margin: 10,
                columns: [
                    {
                        margin: [40, 0, 0, 0],
                        // usually you would use a dataUri instead of the name for client-side printing
                        // sampleImage.jpg however works inside playground so you can play with it
                        //image: 'http://'+window.location.host+'/img/logo.png',
                        //image: 'https://sedecarabayllo.iepmonserrat.edu.pe/img/logo.png',
                        //svg: `<svg> ...`),// <-- Usando svg OK, pero se debe poner un solo path
                        //image: await getBase64ImageFromURL("/img/logo.png"),// <-- Usando base 64 OK
                        //image: "@unensstorage/logosquare.png",// <-- Usando filesystem de laravel - no funciona :(
                        image: await getBase64ImageFromURL("/documents/mycompany/logos/logomembrete.png"),// <-- Usando base 64 OK
                        width: 40
                    },
                    {
                        margin: [-30, 0, 0, 0],
                        //v-if="confGlobal.value.EXPORT_TABLE_ADVANCED_TITLE == '1'"  EXPORT_TABLE_ADVANCED_SUBTITLE
                        //text : 'COLEGIO UNENS\nEducación integral\n\n'+(titleExport ?? 'Total '+modulos+' : '+expItems.length),
                        text: ' \n \n\n' + (titleExport ?? 'Total ' + modulos + ' : ' + expItems.length),
                        alignment: 'center',
                        style: 'header'
                    }

                ],

                //margin: [10, 0, 0, 10],
                /* text : (titleExport ?? 'Total '+modulos+' : '+expItems.length),
                alignment: 'left' */

            },


            footer: function (currentPage, pageCount) { return [{ text: 'Fecha de consulta: ' + fechaHoy + ', Pag. ' + currentPage.toString() + ' de ' + pageCount, alignment: 'right', margin: [0, 0, 40, 0] }] },
            /*
            footer: function(currentPage, pageCount, pageSize) {
            // you can apply any logic and return any valid pdfmake element
  
              return [
                { text: 'simple text', alignment: (currentPage % 2) ? 'left' : 'right' },
                { canvas: [ { type: 'rect', x: 170, y: 32, w: pageSize.width - 170, h: 40 } ] }
              ]
            },
            */


            content: [
                {
                    // margin: [horizontal, vertical]
                    //margin: [15, 20],// <-- Sólo aplica a la primera página
                    layout: 'lightHorizontalLines', // optional
                    table: {
                        // headers are automatically repeated if the table spans over multiple pages
                        // you can declare how many rows should be treated as headers
                        headerRows: 1,

                        // Ancho de columnas
                        //widths: [ '*', 'auto', 100, '*' ],
                        //widths: [ 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto' ],
                        widths: colWith,

                        /*body: [
                          [ 'First', 'Second', 'Third', 'The last one', 'First', 'Second', 'Third', 'The last one' ],
                          [ 'Value 1', 'Value 2', 'Value 3', 'Value 4', 'Value 1', 'Value 2', 'Value 3', 'Value 4' ],
                          [ { text: 'Bold value', bold: true }, 'Val 2', 'Val 3', 'Val 4', { text: 'Bold value', bold: true }, 'Val 2', 'Val 3', 'Val 4' ]
                        ]
                        */
                        body: dataExport
                    }
                }
            ],
            styles: {
                header: {
                    fontSize: 11,
                    bold: true
                }/* ,
            anotherStyle: {
              italics: true,
              alignment: 'right'
            } */
            },
            defaultStyle: {
                fontSize: 9,
                bold: false
            }
        };
        //console.log(docDefinition.content[0].body)
        //pdfMake.createPdf(docDefinition).open();

        if (ext == 'print') {
            pdfMake.createPdf(docDefinition).print();
        } else {
            pdfMake.createPdf(docDefinition).download(modulos + 'Report');
        }

    } else {
        // Guardar txt
        var saveData = (function () {
            var a = document.createElement("a");
            // document.body.appendChild(a);
            // a.style = "display: none";
            return function (data, fileName) {
                /* var json = JSON.stringify(data),
                    blob = new Blob([json], {type: "octet/stream"}), <-- Prueba descarga Json*/
                var fileplane = data,
                    blob = new Blob([fileplane], { type: "octet/stream" }),
                    url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);
            };
        }());

        // Se descarga prueba Json:
        /* var data = { x: 42, s: "hello, world", d: new Date() },
            fileName = "my-download.json"; */

        /* nombre de txt de alta y baja -> No es relevante pero que sea .txt
        cabecera del txt: 01 (2), RUC (11), Nro de clase (3) todas las sedes es 000, PEN (3), fecha de hoy (10), 010 (versión 3 dígitos), campo vació de 7 espacios, P (1 dígito, P, E,)
        Cuerpo: ... Primero fecha de vencimiento, luego fecha de bloqueo 20301231, 00 (2 espacios), precio (13), decimales (2), precio minimo a cobrar i gual al anterior
        pie: 03, cantida de registros (9 dígitos), monto total (16), 00 (decimales de 2 digitos), total cantidida mínima (16 enteros), 00 */

        // filtrar exportación sólo por los seleccionados
        let arrayitems = []
        for (var i = 0; i < itemsPaginated.value.length; i++) {
            if (selectRows.value[i + 1] == true) {
                arrayitems[i] = itemsPaginated.value[i].id
            }
        }
        let invalidEntries = 0;
        function filterByID(item) {
            if (arrayitems.includes(item.id)) {
                return true;
            }
            invalidEntries++;
            return false;
        }

        //const expItems = items.value;
        const expItems = items.value.filter(filterByID);// <-- Filtrar por id seleccionado
        //console.log(arrayitems)
        //const expFields = mainStore.fields;
        //const expFields = mainStore.fields.filter(col => !col.noexport);// <-- Quitar columnas si noexport es true
        const dataExport = ref([])
        let sumatotal_ttc = 0

        if (searchFieldCol.value['formatTxt'] == 1) {
            // BBVA

            // Head - Agregar espacios 360 campos
            let datos = '01' + rucEntity + '000PEN' + fecha_hoy_8C + '001       ' + tipoTxt + '                                                                                                                                                                                                                                                                                                                                  ' + '\n'// <-- head

            expItems.forEach((client, index) => {
                //Definir que el arreglo index también será un arreglo
                // y así se crea el arreglo multidimensional Ref https://stackoverflow.com/questions/16300036/multidimensional-array-in-javascript-cannot-set-property-0-of-undefined
                dataExport.value[index] = []
                let fullname = client['apellidos'] + ' ' + client['nombres']
                let documento = client['num_doc']
                let label = client['label']
                let fecha_emision = client['fecha_emision']
                let fecha_vencimiento = client['fecha_vencimiento']
                let total_ttc = client['total_ttc']
                sumatotal_ttc += parseFloat(total_ttc)

                let fullnameSli = fullname.slice(0, 30)// <-- Si sobrepasan los 30 cortarlo
                let fullnamePad = fullnameSli.padEnd(30, ' ')// <-- Aumentar al final espacios vacíos para llegar a 30
                let fullnameNormalize = fullnamePad.normalize("NFD").replace(/[\u0300-\u036f]/g, "")// <-- Quitar caracteres extraños, tilde y Ñ.
                let labelPad = label.padEnd(40, ' ')
                let fecha_emision_rep = fecha_emision.replaceAll('-', '')// <-- replace() sólo encuentra un caracter o con expresión regular
                let fecha_vencimiento_rep = fecha_vencimiento.replaceAll('-', '')
                let total_ttc_rep = total_ttc.replace('.', '')
                let total_ttc_pad = total_ttc_rep.padStart(15, '0')//<-- Aumentar al principio con espacios vacios para completar, al 13 se aumenta 2 caracteres por  los decimales
                datos += '02' + fullnameNormalize + documento.slice(0, 8) + labelPad + fecha_vencimiento_rep + txtFechaBloqueo + '00' + total_ttc_pad + total_ttc_pad + '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000L000000000000000                                    ' + '\n'// <-- body

            })
            let cantRegistros = expItems.length
            //console.log(cantRegistros)
            let cantReg = cantRegistros.toString()
            let cantRegPad = cantReg.padStart(9, '0')
            let sumatotal_ttc_str = sumatotal_ttc.toFixed(2).toString()
            let sumatotal_ttc_rep = sumatotal_ttc_str.replace('.', '')
            let sumatotal_ttc_pad = sumatotal_ttc_rep.padStart(18, '0')// <-- incluye decimales
            console.log(sumatotal_ttc_str + ' incluye decimales:' + sumatotal_ttc_rep)

            //Foot - Agregar ceros y espacios
            datos += '03' + cantRegPad + sumatotal_ttc_pad + sumatotal_ttc_pad + '000000000000000000                                                                                                                                                                                                                                                                                                       '// <-- foot

            var data = datos,
                fileName = 'ImportTxt_' + rucEntity + '_' + labelEntity + '_' + tipoTxt + '_' + fecha_hoy_8C + ".txt";
        } else if (searchFieldCol.value['formatTxt'] == 2) {
            // Scotiabank

            /* let integration_account_number = ''
            let integration_code_service = ''
            let integration_concept_code = ''
            let integration_concept_description = ''
            let integration_abono_account = ''
            let integration_name_file = ''
            integration_indicador_ca
            integration_pago_parcial
            rucEntity
            fecha_hoy_8C
            tipoTxt <-- en el detalle */

            // Head - Agregar espacios 360 campos
            let cantRegistros = expItems.length
            //console.log(cantRegistros)
            let cantReg = cantRegistros.toString()
            let cantRegPad = cantReg.padStart(7, '0')
            let dias_mora = '000'
            let otros_datos_mora_descuentos = pad(0, 56) // <-- Rellenar de ceros 148 - 93
            let fecha_inicio_ca = fecha_hoy_8C // Cobro automatico
            let fecha_fin_ca = fecha_hoy_8C // Cobro automatico
            //integration_account_number = integration_account_number.toString() + '  '
            integration_account_number = integration_account_number.toString()
            // El head luego del forech pues se suma el total en el head

            let datos_body = ''
            expItems.forEach((client, index) => {
                //Definir que el arreglo index también será un arreglo
                // y así se crea el arreglo multidimensional Ref https://stackoverflow.com/questions/16300036/multidimensional-array-in-javascript-cannot-set-property-0-of-undefined
                dataExport.value[index] = []
                let id_tecnico = client['id']
                let id_tecnico_str = id_tecnico.toString() // convertir en string
                let id_tecnico_pad = id_tecnico_str.padEnd(15, ' ')
                let documento = client['num_doc']
                documento = documento.padEnd(15, ' ')
                let codigo_agrupacion = '           ' //pad(' ', 11) // <-- Rellenar espacios 49-59 <-- 11 digitos ruc o dni, no se usa
                let situacion = '0'; // pendiente de pago
                let moneda_cobro = '0000'; // 0000 soles, 0001 dólares
                let fullname = client['apellidos'] + ' ' + client['nombres']
                let fullnameSli = fullname.slice(0, 20)// <-- Si sobrepasan los 30 cortarlo
                let fullnamePad = fullnameSli.padEnd(20, ' ')// <-- Aumentar al final espacios vacíos para llegar a 30
                let fullnameNormalize = fullnamePad.normalize("NFD").replace(/[\u0300-\u036f]/g, "")// <-- Quitar caracteres extraños, tilde y Ñ.
                let label = client['label']
                let labelPad = label.padEnd(30, ' ')
                let codigo_concepto = integration_concept_code
                let total_ttc = client['total_ttc']
                let total_ttc_rep = total_ttc.replace('.', '')
                let total_ttc_pad = total_ttc_rep.padStart(11, '0')//<-- Aumentar al principio con espacios vacios para completar, al 13 se aumenta 2 caracteres por  los decimales
                let otros_conceptos = pad('0', 65) // Otros conceptos
                let total_cobrar = total_ttc_rep.padStart(15, '0') // <-- El total son 15 espacios
                let saldo_deuda = total_cobrar
                let procentaje_minimo = '00000000'
                let fecha_emision = client['fecha_emision']
                let fecha_emision_rep = fecha_emision.replaceAll('-', '')// <-- replace() sólo encuentra un caracter o con expresión regular
                let fecha_vencimiento = client['fecha_vencimiento']
                let fecha_vencimiento_rep = fecha_vencimiento.replaceAll('-', '')
                let dias_prorroga = '900'
                let indicador_cargo_automatico = '01' // 01 cuotas variables, 02 cargo automático
                let tipoOperacion = searchFieldCol.value['tipoTxt']

                sumatotal_ttc += parseFloat(total_ttc)

                datos_body += 'D' + integration_account_number + '  ' + integration_code_service + documento + id_tecnico_pad + codigo_agrupacion + situacion + moneda_cobro + fullnameNormalize + labelPad + codigo_concepto + total_ttc_pad + otros_conceptos + total_cobrar + saldo_deuda + procentaje_minimo + '0' + fecha_emision_rep + fecha_vencimiento_rep + dias_prorroga + '              ' + indicador_cargo_automatico + tipoOperacion + '                      *' + '\n'// <-- body
                console.log('Det ' + datos_body.length)
                console.log('ID ' + id_tecnico_pad)
            })

            let sumatotal_ttc_str = sumatotal_ttc.toFixed(2).toString()
            let sumatotal_ttc_rep = sumatotal_ttc_str.replace('.', '')
            let sumatotal_ttc_pad = sumatotal_ttc_rep.padStart(17, '0')// <-- incluye decimales

            let sumatotal_dolar = pad(0, 17) // <-- Rellenar de ceros
            // <-- Al final son 124 espacios
            let datos = 'H' + integration_account_number + '  ' + integration_code_service + cantRegPad + sumatotal_ttc_pad + sumatotal_dolar + rucEntity + fecha_hoy_8C + txtFechaBloqueo + '000' + dias_mora + otros_datos_mora_descuentos + fecha_inicio_ca + fecha_fin_ca + integration_indicador_ca + '                                                                                                                            *' + '\n'// <-- head
            //console.log(sumatotal_ttc_str + ' incluye decimales:' + sumatotal_ttc_rep)
            console.log('Head ' + datos.length)
            console.log('Head ' + integration_account_number)

            datos += datos_body

            //Foot - Agregar ceros y espacios
            let concept_description = integration_concept_description.padEnd(30, ' ')
            datos += 'C' + integration_account_number + '  ' + integration_code_service + integration_concept_code + concept_description + integration_pago_parcial + integration_abono_account + '                                                                                                                                                                                                                                  *'// <-- foot
            console.log('Foot ' + datos.length)
            var data = datos,
                fileName = integration_name_file;
        }

        saveData(data, fileName);
    }

}

// para aumentar ceros o espacios para la exportación de txt
function pad(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

//console.log(mainStore.fields);

const viewCard = (id) => {
    const ruta = mainStore.ruta + '-show'
    Inertia.get(route(ruta, {
        'id': id
    }
    ))
}

// Obtener img base 64
const getBase64ImageFromURL = (url) => {
    return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.onload = () => {
            var canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;

            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            var dataURL = canvas.toDataURL("image/png");

            resolve(dataURL);
        };

        img.onerror = error => {
            reject(error);
        };

        img.src = url;
    });
}

// Formatos de fecha y tiempo
const formatDate = (datesource, format = 'day') => {
    //var now = new Date().toLocaleDateString()
    if (datesource) {
        var date = new Date(datesource + 'T00:00:00')// <-- Con let no funcionaba <-- Agregar la hora para que no reste un día por la zona horaria del navegador
        //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
        let result = ''
        if (format == 'day') {
            result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
        } else if ((format == 'Y')) {
            result = date.getFullYear()
        }
        
        return result
    }

}

//console.log(props.object)
const formatDateTime = (datetime) => {
    if (datetime) {
        var date = new Date(datetime)// <-- Con let no funcionaba
        //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
        let result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear() + ' ' + (date.getHours() > 9 ? '' : '0') + date.getHours() + ':' + (date.getMinutes() > 9 ? '' : '0') + date.getMinutes()
        return result
    }

}


/**
 * Menú personalizado
 */
const showListColMenu = ref(false)
const arrayFormParam = mainStore.userParam
let initUserParam = {}

if (mainStore.userParam) {
    arrayFormParam.forEach((param) => {
        initUserParam[param.col] = param.check
    });
}
const formParam = ref(initUserParam)
const updateUserParam = () => {
    if (showListColMenu.value) {
        let url = '/userparam/updateorstore';
        let objectNewParam = formParam.value
        let arrayNewParam = []
        let textNewParam = ''
        // Como es un objeto reactivo no se puede usar forEach
        for (const [key, value] of Object.entries(objectNewParam)) {
            //console.log(key)
            if (value === true) {
                arrayNewParam.push(key)
            }
        }
        if (arrayNewParam) textNewParam = arrayNewParam.toString()
        //console.log(objectNewParam)
        console.log(arrayNewParam)
        console.log('update_col : ' + textNewParam)

        let newparam = mainStore.ruta + '-list'
        if (mainStore.modulo == 'cobranzas') {
            newparam = 'cobranzas-list'
        }

        let formCampos = {
            param: newparam,
            value: textNewParam
        }
        axios.post(url, formCampos).then((response) => {
            //let respuesta = response.data;
            console.log('fields update ok');
            //console.log(dataList.value);
            //Inertia.reload({ only: ['studens']})
        }).catch(function (error) {
            console.log(error);
        });
    }
}
// Fin de menú Personalizado

// Alertas
const isAlertActive = ref(false)
const isAlertDangerActive = ref(false)
const messageAlert = ref('')
const messageLastAction = ref('')
const messageError = ref('')
/* const error = ref(0)
const errors = ref([]) */
const colorAlert = ref('success')
const errormsg = ref(null)
const errors = ref(0)
const alertIndex = ref(0)

const showAlert = (message = '', type, time = 1) => {

    messageAlert.value = message
    colorAlert.value = type// <-- Tipo define el color
    isAlertActive.value = true

    // grabar última acción
    messageLastAction.value = message

    /* if (color == 'danger') {
        isAlertDangerActive.value = true
    } else {
        isAlertActive.value = true
    } */
    setTimeout(() => {
        isAlertActive.value = false
        //messageAlert.value = '' <-- Comentar para que no halla error de prop indefined en el componente NotificationAlert
        /* if (color == 'danger') {
            isAlertDangerActive.value = false
        } else {
            isAlertActive.value = false
        } */
        errormsg.value = ref(null)
        errors.value = ref(0)
        alertIndex.value = ref(0)
        //isActionMassive.value = false
    }, time * 1000)// LRR bind(this)


}

</script>

<!-- Menu Dropdown -->
<!-- <script>
export default {
	data() {
		return {
			show: false,
		};
	},
};
</script> -->
    
<template>
    <!-- Modal de opciones avance de pagos desde cobranzas -->
    <!-- <CardBoxModal v-model="isModalActive" hasCancel :title="(rowAction + ' ' + titleModal)" @confirm="isConfirm" @cancel="isCancel" :sizeModal="(modulo == 'cobranzas' ? 'ajuste' : '')">
        {{ rowID }}
        <div v-if="isErrorForm" class="mb-4">
          <div class="font-medium text-red-600">Ups! Debe registrar los campos requeridos *</div>
        </div>
        
        <template  v-if="(isRef || modulo=='Nivel' || modulo=='Curso')">
          <div>
            <BreezeLabel for="ref" :value="'Código' + (modulo=='Curso' ? ' (ejem. Geometría : GEOM_SEC2)' : '')" :required="true"/>
            <BreezeInput id="ref" type="text" class="mt-1 block w-full" v-model="form.ref" required autocomplete="ref" />
          </div>
          
        </template>
        <template v-if="modulo == 'cobranzas'">
          <div> 
            <BreezeLabel for="nombre" value="Nombre" :required="true"/>
            <BreezeInput id="label" type="text" class="mt-1 block w-full" v-model="form.label" required autocomplete="label" />
          </div>
          <div>
            <BreezeLabel for="label_short" value="Nombre corto (ejemplo: 2do)" />
            <BreezeInput id="label_short" type="text" class="mt-1 block w-full" v-model="form.label_short" required autocomplete="label_short" />
          </div>
          <div>
            <BreezeLabel for="parent" value="Añadir en" />
            
            <select v-model="form.parent" class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
              <option value="" selected></option>
              <option v-for="option in select1" :value="option.id">{{ option.label }}</option>
            </select>
          </div>
          <div>
            <BreezeLabel for="position" value="Posición" />
            <BreezeInput id="position" type="number" class="mt-1 block w-full" v-model="form.position" required autocomplete="position" />
          </div>
          <div>
            <BreezeLabel for="ciclo" value="Ciclo curricular al que pertenece este nivel ejem: 2" />
            <BreezeInput id="ciclo" type="text" class="mt-1 block w-full" v-model="form.ciclo_curricular" required autocomplete="ciclo" />
          </div>
          <div v-if="select1.length">
            <BreezeLabel for="entity" :value="'Entidad' + ' (empresa)'"/>
           
            <VueSelect v-if="allStudents.length" class="w-full min-w-[200px] border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1"
              v-model="idStudentOrder"
              :options="allStudents"
              :get-option-label="(option) => `(${option.num_doc}) ${option.apellidos} ${option.nombres}`"
              placeholder="Seleccionar estudiante"/>
          </div>
        </template>

    </CardBoxModal> -->

    <!-- Vista previa -->
    <CardBoxModal v-model="isModalFullActive" title="Vista previa" sizeModal="full" hasCancel><!-- tien el botón de cancelar superior-->
        <div class="flex justify-center w-full">
            <embed :src="modalFullSrc" class="min-h-[80vh] max-h-[80vh] lg:min-h-[80vh]" :class="(modalFullSrc && (['pdf', 'xlsx', 'pptx', 'docx'].includes(modalFullSrc.split('.').pop())) ? 'w-full' : 'w-auto')"><!-- w-full es para documetnos w-auto para imágenes-->
        </div>
    </CardBoxModal>

    <CardBoxModal v-model="isModalDangerActive" title="Por favor confirmar" button="danger" has-cancel @confirm="isConfirm" @cancel="isCancel">
        <p>Confirmar esta acción masiva</p>
    </CardBoxModal>

    <!-- <CardBoxModal
        v-model="isModalDangerActive"
        title="Por favor confirmar"
        button="danger"
        has-cancel
        @confirm="isConfirm" @cancel="isCancel"
    >   
        <p>Está seguro de <b v-text="rowAction"></b></p>
        <p>Este registro?</p>
    </CardBoxModal> -->
    <!-- Fin modal -->

    <NotificationAlert v-model="isAlertActive" :message="messageAlert" :color="colorAlert" />

    <!-- <div v-if="loading" class="flex flex-col justify-center items-center absolute bottom-0 bg-white w-full z-50 bg-opacity-80 h-full">
        <div class="mb-10">
          <div class="relative inline-flex">
              <div class="w-8 h-8 bg-rose-600 rounded-full"></div>
              <div class="w-8 h-8 bg-rose-600 rounded-full absolute top-0 left-0 animate-ping"></div>
              <div class="w-8 h-8 bg-rose-600 rounded-full absolute top-0 left-0 animate-pulse"></div>
          </div>
      </div>
        <div class="border-gray-300 h-20 w-20 animate-spin rounded-full border-8 border-t-rose-600 mb-10" />
        <p class="text-rose-600">Procesando</p>
        <div>
          <button type="button"
              class="inline-flex  items-center btn btn-rose text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg ">
              <div class="border-rose-400 h-5 w-5 animate-spin rounded-full border-4 border-t-white mr-2" />
              Cargando
          </button>
      </div>
    </div> -->
    <div v-if="loading" class="fixed container-snap h-full w-full z-50 left-0 top-0 overflow-hidden">
        <div class="flex flex-col items-center justify-center w-full h-full bg-white bg-opacity-80">
            <div class="border-gray-300 h-20 w-20 animate-spin rounded-full border-8 border-t-rose-600 mb-2"></div>
            <p class="text-rose-600">Procesando</p>
        </div>
    </div>

    <div class="grid grid-cols-2 lg:grid-cols-6 gap-2 mb-3" :class="loading ? 'pointer-events-none' : ''">
        <div class="col-span-2 flex items-center">
            <h3 class="ml-3">{{ modulos }} : {{ items.length }}</h3>
        </div>
        <!-- Reubicar botones de exportar -->
        <div class="col-span-2 lg:col-span-2 flex items-center justify-center">
            <template v-if="exporteable">
                <div class="inline-block pr-2">
                    <IconRounded color="" :icon="mdiFilePdfBox" title="Exportar a PDF (Si es más de 8 columnas será horizontal, si es más de 14 columnas la hoja será A3)" class="ml-1 text-red-800" @click="exportFile('pdf')" />
                </div>
                <div class="inline-block">
                    <IconRounded color="" :icon="mdiFileTableOutline" title="Exportar a Excel" class="ml-1 text-green-700" @click="exportFile('xlsx')" />
                </div>
                <div v-if="modulo == 'payementOrder' && showDownloadTxt && countChecked" class="inline-block">

                    <IconRounded color="" :icon="mdiFileDocument" title="Exportar a txt" class="ml-1 text-blue-700" @click="exportFile('txt')" />
                </div>

                <!--<div class="inline-block">
            <IconRounded color="" :icon="mdiPrinter" title="Imprimir" class="ml-1 text-blue-700"
          @click="exportFile('print')" />
          </div>-->
            </template>
            <div v-if="modulo == 'payementOrder' && showDownloadTxt && countChecked" class="w-24 inline-block">
                <select class="w-22 ml-3 rounded-l" v-model="searchFieldCol['formatTxt']">
                    <option value="1">BBVA</option>
                    <option value="2">SBP</option>
                </select>
                <select v-if="searchFieldCol['formatTxt'] == 2" class="w-22 ml-3 rounded-l" v-model="searchFieldCol['tipoTxt']">
                    <option value="A">A</option>
                    <option value="M">M</option>
                    <option value="E">E</option>
                </select>
            </div>
            <div v-if="isSearchYear" class="w-24 inline-block">
                <input name="year" class="w-16 ml-3 rounded-lg" type="text" v-model="searchFieldCol['anioSearch']" :placeholder="anioActualRef" @keyup.enter="listarData()">
            </div>
            <!--<BaseIcon :path="mdiFileTableOutline" :size="32" class="text-green-700"/>-->
        </div>
        <div v-if="!noPaginate" class="col-span-2 lg:col-span-2 flex items-center justify-end w-full">
            <div class="grid grid-cols-2 lg:flex flex-row gap-4 w-full lg:w-auto">
                <div class="col-span-1 ">
                    <select class="w-full lg:w-auto" v-model="perPage">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="250">250</option>
                        <option value="500">500</option>
                        <option value="1000">1000</option>
                        <option value="2000">2000</option>
                    </select>
                </div>
                <!--<span class="ml-1">
            Página  <input class="ml-1 w-16 border-l-transparent border-t-transparent border-r-transparent border-b-gray-600" type="number" v-model="currentPage"> de {{ numPages }}
          </span>-->
                <div class="col-span-1 border-b border-gray-400 flex justify-end">
                    <span class="text-sm">
                        Pág.
                        <select class="ml-1 w-18 border-0 focus:border-transparent focus:ring-0 pr-8" v-model="currentPage">
                            <option v-for="page in pagesList" :value="page">{{ (page + 1) }}</option>
                        </select>
                        de
                        <span class="font-semibold pl-2">
                            {{ numPages }}
                        </span>
                    </span>
                </div>
            </div>
        </div>
    </div>
    <div v-if="!noSearch" class="grid grid-cols-4 lg:grid-cols-8 gap-4 mb-4" :class="(searchAdvance ? 'lg:hidden' : '')">
        <!-- Searchs @change="buscar=''; buscar2='';" -->
        <div class="col-span-2 lg:col-span-1">
            <select v-model="searchField" @change="searchVal = ''" class="w-full">
                <option value="" selected>Buscar</option>
                <option v-for="field in fields" :value="field.col">{{ field.name }}</option>
            </select>
        </div>

        <div class="col-span-2 lg:col-span-2">
            <!--
          <span v-if="!searchField.indexOf('status')">
          <select class="ml-1 mb-3 rounded-lg w-full" v-model="searchVal">
            <option value="" selected>Todos</option>
            <option value="0" selected>Pte. pago</option>
            <option value="1" selected>Pagado</option>
          </select>
        </span>
        -- Tipo de estudiante columna 4 --
        <span v-else-if="searchField.includes('type')">
          <select class="ml-1 mb-3 rounded-lg w-full" v-model="searchVal">
            <option value="" selected>Todos</option>
            <option value="0" selected>Nuevo</option>
            <option value="1" selected>Antiguo</option>
            
          </select>
        </span>

        -- Files fileForLevel la columna 1 es de niveles --
        <span v-else-if="searchField.includes('src_object_id')">
          <select class="ml-1 mb-3 rounded-lg w-full" v-model="searchVal">
            <option value="" selected>Todos</option>
            <option v-for="(field, index) in fields[1].replace" :value="index">{{ field }}</option>

          </select>
        </span>
        -- Files estudiante es de niveles --
        <span v-else-if="searchField.includes('id_level')">
          <select class="ml-1 mb-3 rounded-lg w-full" v-model="searchVal">
            <option value="" selected>Todos</option>
            <option v-for="(field, index) in fields[5].replace" :value="index">{{ field }}</option>

          </select>
        </span>
        -- Files estudiantes es de classroom --
        <span v-else-if="searchField.includes('id_classroom')">
          <select class="ml-1 mb-3 rounded-lg w-full" v-model="searchVal">
            <option value="" selected>Todos</option>
            <option v-for="(field, index) in fields[6].replace" :value="index">{{ field }}</option>

          </select>
        </span>
        -->

            <!-- Mapear (crear array sólo de la columna col en el bojejto field) buscr si exise el nombre del campo y condicionar sólo foráneos o booleanos -->
            <span v-if="(col = fields.map(c => c.col).indexOf(searchField)) >= 0 && (fields[col].type == 'foraign' || fields[col].type == 'boolean' || fields[col].type == 'status')">
                <select class="rounded-lg w-full" v-model="searchVal">
                    <option value="" selected>Todos</option>
                    <option v-for="(field, index) in fields[col].replace" :value="index">{{ field }}</option>

                </select>
            </span>
            <span v-else-if="(col = fields.map(c => c.col).indexOf(searchField)) >= 0 && (fields[col].type == 'number')">
                <input class="rounded-lg w-full" type="number" v-model="searchVal">
            </span>
            <span v-else-if="(col = fields.map(c => c.col).indexOf(searchField)) >= 0 && (fields[col].type == 'date')">
                <input class="rounded-lg w-full" type="date" v-model="searchVal">
            </span>
            <span v-else>
                <input class="rounded-lg w-full" type="text" v-model="searchVal" :autofocus="searchfocus">
            </span>
        </div>

        <!-- Reubicar botones de exportar -->


        <!-- Múltiple búsqueda probar https://stackoverflow.com/questions/31831651/javascript-filter-array-multiple-conditions -->
    </div>

    <!-- LRR Inputa para buscar de forma más avanzada por criterio -->
    <!-- <BreezeInput id="search" type="text" class="inline-block w-full" v-model="buscarCriterio" autofocus
            autocomplete="label" @keyup.enter="listar(selectCriterio, buscarCriterio)" /> -->

    <!-- Checked rows -->
    <!-- - LRR <div v-if="checkedRows.length" class="p-3 bg-gray-100/50 dark:bg-slate-800">   -->
    <div v-if="countChecked" class="text-sm grid grid-cols-1 sm:grid-cols-2 lg:flex lg:flex-wrap items-center gap-3 mb-3" :class="loading ? 'pointer-events-none' : ''">
        <!-- <span
        v-for="(selectRow, index) in selectRows"
        :key="index"
        class="inline-block px-2 py-1 rounded-sm mr-2 text-sm bg-gray-100 dark:bg-slate-700"
        >
        {{ selectRow == true ? selectRow : ''}}
        </span> -->
        <div class="font-semibold sm:col-span-2">
            {{ countChecked }} filas seleccionadas
        </div>
        <!-- - LRR <span
        v-for="checkedRow in checkedRows"
        :key="checkedRow.id"
        class="inline-block px-2 py-1 rounded-sm mr-2 text-sm bg-gray-100 dark:bg-slate-700"
        >
        {{ checkedRow.apellidos }}
        </span> -->
        <div>
            <select class="w-full" v-model="massaction">
                <option value="" disabled>Acción masiva</option>
                <option v-if="modulo == 'estudiante' && changeOption1" value="enabled">Habilitar Acceso</option>
                <option v-if="modulo == 'estudiante' && changeOption1" value="disabled">Deshabilitar Acceso</option>
                <option v-if="modulo == 'estudiante' && changeOption1" value="activar">Establecer a Activo</option>
                <option v-if="modulo == 'estudiante' && changeOption1" value="ingresante">Establecer a Ingresante</option>
                <option v-if="modulo == 'estudiante' && changeOption1" value="egresado">Establecer a Egresado</option>
                <option v-if="modulo == 'estudiante' && changeOption1" value="retirado">Establecer a retirado</option>
                <option v-if="modulo == 'estudiante' && changeOption1" value="pensionpref">Establecer pensión Pref.</option>
                <option v-if="modulo == 'estudiante' && changeOption1" value="compromisopago">Establecer compromiso de pago</option>

                <option v-if="modulo == 'estudiante' && changeOption1" value="tipo_stdt">Establecer tipo Estudiante</option>

                <option v-if="modulo == 'calification'" value="publicar">Publicar notas</option>
                <option v-if="modulo == 'calification'" value="nopublicar">No publicar notas</option>
                <option v-if="modulo == 'admisionpuntaje'" value="publicar">Publicar puntaje EAP</option>
                <option v-if="modulo == 'admisionpuntaje'" value="nopublicar">No publicar puntaje EAP</option>

                <option v-if="modulo == 'payementOrder'" value="pagada">Establecer pagadas</option>
                <option v-if="modulo == 'payementOrder' && confGlobal.value.FINANCIERA_USE_PAGO_PARCIAL == 1" value="pagoparcial">Establecer pago parcial</option>
                <option v-if="modulo == 'payementOrder'" value="ptepago">Establecer Pte. pago</option>
                <option v-if="modulo == 'payementOrder'" value="noalta">Establecer Sin alta</option>
                <option v-if="modulo == 'payementOrder'" value="precio">Cambiar precio</option>
                <option v-if="modulo == 'payementOrder'" value="vencimiento">Cambiar Vencimiento</option>
                <option v-if="modulo == 'payementOrder'" value="nota">Cambiar Nota/Obervación</option>
                <option v-if="modulo == 'payementOrder' && confGlobal.value.FINANCIERA_USE_FACTURACION == 1" value="facturar">Facturar pagadas por comprobante</option>
                <option v-if="modulo == 'payementOrder' && confGlobal.value.FINANCIERA_USE_FACTURACION == 1" value="clasificarfacturado">Clasificar como Facturado</option>
                <option v-if="modulo == 'payementOrder' && confGlobal.value.FINANCIERA_USE_FACTURACION == 1" value="clasificarnofacturado">Clasificar como No Facturado</option>
                <option v-if="modulo == 'payementOrder' && confGlobal.value.FINANCIERA_USE_FACTURACION == 1" value="facturaronlystudent">Facturar pagadas a un único comprobante</option>
                <option v-if="modulo == 'payementOrder'" value="matricular">Matricular (Ord. Pagadas)</option>

                <option v-if="modulo == 'facture'" value="enviarsunat">Enviar a Sunat</option>
                <option v-if="modulo == 'facture'" value="consultarsunat">Consultar a Sunat</option>
                <option v-if="modulo == 'facture'" value="sendemail">Enviar Email del Resp. Fact. o Pag.</option>
                <option v-if="modulo == 'facture'" value="cambiarfecha">Cambiar Fecha de Emisión</option>
                <option v-if="modulo == 'facture'" value="cambiarmonto">Cambiar Monto</option>
                <option v-if="modulo == 'facture'" value="anular">Anular (dar de baja)</option>
                <!-- <option v-if="modulo == 'facture' && countChecked == 1" value="dardebaja">Solicitud de baja (anulación)</option> -->
                <option v-if="modulo == 'facture' && (typeof confGlobal.value.FINANCIERA_FACTURACION_SERIE_BOLETA_NC !== 'undefined')" value="notacredito">Crear nota de crédito por anulación</option>

                <option v-if="modulo == 'product' && countChecked == 1" value="ingresostock">Ingreso de Stock</option>
                <option v-if="modulo == 'product' && countChecked == 1" value="salidastock">Salida de Stock</option>

                <option v-if="modulo == 'freeday'" value="freedayaprobar">Aprobar solicitudes</option>
                <option v-if="modulo == 'freeday'" value="freedaydesaprobar">En espera de aprobación</option>
                <option v-if="modulo == 'freeday'" value="freedaycancelar">Cancelar Solicitudes</option>
                <option v-if="modulo == 'freeday'" value="freedaychangedate">Cambiar Fecha Inicio - Fin</option>

                <option v-if="massDelete" value="eliminar">Eliminar seleccionado</option>

                <!-- <option v-if="changeSelect1 && modulo == 'estudiante' && originType == 'estudiante'" value="changeAulaEstu">Cambiar {{ titleSelect1 }} Estudio</option>
            <option v-if="changeSelect1 && modulo == 'estudiante' && originType == 'estudiante'" value="changeAulaMatr">Cambiar {{ titleSelect1 }} matrícula</option>
            <option v-if="changeSelect1 && modulo == 'estudiante' && originType == 'estudiante'" value="changeAulaUgel">Cambiar {{ titleSelect1 }} Ugel</option> -->
                <option v-if="changeSelect1" value="changeSelect1">Cambiar {{ titleSelect1 }}</option>
                <option v-if="changeSelect2" value="changeSelect2">Cambiar {{ titleSelect2 }}</option>
                <option v-if="changeSelect3" value="changeSelect3">Cambiar {{ titleSelect3 }}</option>
                <option v-if="changeSelect4" value="changeSelect4">Cambiar {{ titleSelect4 }}</option>
                <!-- <option value="financiero_pp">Pdte. de pago</option>
            <option value="financiero_p">Pagado</option> -->
                <!-- <option v-if="modulo == 'Documento' && originType == 'file_document_student'" value="notifyadmin">Notificar al administrador</option> -->
                <option v-if="modulo == 'Documento' && modulos == 'Recursos de estudio'" value="usethisyear">Usar recurso para este año</option>
                <option v-if="modulo == 'Documento' && modulos == 'Documentos'" value="filechangeiniciofin">Cambiar Fecha Inicio - Fin</option>
            </select>
        </div>
        <!-- <span v-if="changeSelect1 && (massaction=='changeAulaEstu' || massaction=='changeAulaMatr' || massaction=='changeAulaUgel')">
          <select class="ml-3 mb-3 rounded-lg" v-model="id_select1">
              <option value="" selected disabled>Seleccionar {{ titleSelect1 }}</option>
              <option v-for="(option, index) in select1" :value="index">{{ option }}</option>
            </select>
        </span> -->
        <div v-if="changeSelect1 && massaction == 'tipo_stdt'">
            <select class="w-full" v-model="id_select1">
                <option value="" selected disabled>Seleccionar tipo estudiante</option>
                <option value="0">Nuevo</option>
                <option value="1">Antiguo</option>
            </select>
        </div>
        <div v-if="modulo == 'estudiante' && massaction == 'pensionpref'">
            <input type="number" v-model="massiveFieldValue">
        </div>
        <div v-if="modulo == 'estudiante' && massaction == 'compromisopago'">
            <input type="date" v-model="massiveFieldValue">
        </div>
        <div v-if="changeSelect1 && massaction == 'changeSelect1'">
            <VueSelect v-if="vueselectmassaction" class="w-full min-w-[250px] select-search-light" v-model="id_select1" :options="select1" :get-option-label="(option) => `${option.label}`" :placeholder="'Seleccionar ' + titleSelect1" @keyup.enter="listarData()" />
            <select v-else class="w-full" v-model="id_select1">
                <option value="" selected disabled>Seleccionar {{ titleSelect1 }}</option>
                <option v-for="(option, index) in select1" :value="index">{{ option }}</option><!-- Mostrar los curos del array construido por columns -->
            </select>
        </div>
        <div v-if="changeSelect2 && massaction == 'changeSelect2'">
            <VueSelect v-if="vueselectmassaction" class="w-full min-w-[250px] select-search-light" v-model="id_select2" :options="select2" :get-option-label="(option) => `${option.label}`" :placeholder="'Seleccionar ' + titleSelect2" @keyup.enter="listarData()" />
            <select v-else class="w-full" v-model="id_select2">
                <option value="" selected disabled>Seleccionar {{ titleSelect2 }}</option>
                <option v-for="(option, index) in select2" :value="index">{{ option }}</option><!-- Mostrar los curos del array construido por columns -->
            </select>
        </div>
        <div v-if="changeSelect3 && massaction == 'changeSelect3'">
            <VueSelect v-if="vueselectmassaction" class="w-full min-w-[250px] select-search-light" v-model="id_select3" :options="select3" :get-option-label="(option) => `${option.label}`" :placeholder="'Seleccionar ' + titleSelect3" @keyup.enter="listarData()" />
            <select v-else class="w-full" v-model="id_select3">
                <option value="" selected disabled>Seleccionar {{ titleSelect3 }}</option>
                <option v-for="(option, index) in select3" :value="index">{{ option }}</option><!-- Mostrar los curos del array construido por columns -->
            </select>
        </div>
        <div v-if="changeSelect4 && massaction == 'changeSelect4'">
            <VueSelect v-if="vueselectmassaction" class="w-full min-w-[250px] select-search-light" v-model="id_select4" :options="select4" :get-option-label="(option) => `${option.label}`" :placeholder="'Seleccionar ' + titleSelect4" @keyup.enter="listarData()" />
            <select v-else class="w-full" v-model="id_select4">
                <option value="" selected disabled>Seleccionar {{ titleSelect4 }}</option>
                <option v-for="(option, index) in select4" :value="index">{{ option }}</option><!-- Mostrar los curos del array construido por columns -->
            </select>
        </div>
        <div v-if="modulo == 'payementOrder' && (massaction == 'precio' || massaction == 'pagada')">
            <input type="text" v-model="massiveFieldValue" :placeholder="(massaction == 'pagada' ? 'Detalle/Operación' : '')" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="32">
        </div>
        <div v-if="modulo == 'payementOrder' && massaction == 'pagada'">
            <input type="date" v-model="massiveFieldValue2">
        </div>
        <div v-if="modulo == 'payementOrder' && massaction == 'vencimiento'">
            <input type="date" v-model="massiveFieldValue">
        </div>
        <div v-if="modulo == 'payementOrder' && massaction == 'nota'">
            <input type="text" v-model="massiveFieldValue">
        </div>
        <div v-if="modulo == 'payementOrder' && massaction == 'facturar' && confGlobal.value.FINANCIERA_FACTURACION_MODIFY_EMISION_DATE == 1">
            Fecha emisión: <input type="date" v-model="massiveFieldValue" title="¡tenga cuidado en la consistencia de correlativo y fecha!">
        </div>
        <div v-if="modulo == 'payementOrder' && massaction == 'facturaronlystudent'">
            <input type="text" v-model="massiveFieldValue" :placeholder="confGlobal.value.FINANCIERA_FACTURACION_GLOSA_DEFAULT_PENSION">
        </div>
        <!-- Product -->
        <div v-if="modulo == 'product' && (massaction == 'ingresostock' || massaction == 'salidastock')">
            <input type="number" v-model="massiveFieldValue" :placeholder="(massaction == 'ingresostock' ? 'Stock Ingreso' : 'Stock Salida')" @click="massiveFieldValue2 = 'Corrección de Stock'">
        </div>
        <div v-if="modulo == 'product' && (massaction == 'ingresostock' || massaction == 'salidastock')"><!-- :set="massiveFieldValue2 = 'Corrección de Stock'" -->
            <!-- <input class="ml-3 mb-3 rounded-lg" type="text" v-model="massiveFieldValue2"> -->
            <input type="text" v-model="massiveFieldValue2">
        </div>
        <!-- Freeday -->
        <div v-if="modulo == 'freeday' && (massaction == 'freedaycancelar')">
            <input type="text" v-model="massiveFieldValue" placeholder="Motivo del rechazo (Opcional)">
        </div>
        <div v-if="modulo == 'freeday' && massaction == 'freedaychangedate'">
            <input type="date" v-model="massiveFieldValue" title="Fecha de Inicio">
            <input type="date" v-model="massiveFieldValue2" title="Fecha de Fin">
        </div>
        <!-- facure -->
        <div v-if="modulo == 'facture' && massaction == 'cambiarfecha' && confGlobal.value.FINANCIERA_FACTURACION_MODIFY_EMISION_DATE == 1">
            Fecha emisión: <input type="date" v-model="massiveFieldValue" title="¡tenga cuidado en la consistencia de correlativo y fecha!">
        </div>
        <div v-if="modulo == 'facture' && massaction == 'cambiarmonto'">
            S/ <input type="text" v-model="massiveFieldValue">
        </div>
        <div v-if="modulo == 'facture' && (massaction == 'anular' || massaction == 'notacredito')">
            Motivo: <input type="text" v-model="massiveFieldValue" title="Motivo de anulación">
        </div>
        <!-- File Documento -->
        <div v-if="modulo == 'Documento' && massaction == 'filechangeiniciofin'">
            <input type="date" v-model="massiveFieldValue" title="Fecha de Inicio">
            <input type="date" v-model="massiveFieldValue2" title="Fecha de Fin">
        </div>
        <!-- Action -->
        <div class="sm:col-span-2">
            <BaseButton color="info" small label="Confirmar" @click="isModalDangerActive = true" />
            <!--  @click="massAction(massaction)" -->
            <!-- @click="massAction(checkedRows, massaction)" -->

            <BaseButton color="danger" small label="Cancelar" @click="cleanVal()" class="ml-3" />
            <!--  @click="massAction(massaction)" -->
            <!-- @click="massAction(checkedRows, massaction)" -->
        </div>
    </div>
    <!-- min-h-[550px]  -->
    <div class="grid grid-cols-1 content-between overflow-x-auto min-h-[450px]" >
        <table :class="loading ? 'pointer-events-none' : (optionsbutton ? ' mb-20' : '')" class="table-responsive">
            <thead class="text-sm">
                <!-- Search Advanced -->
                <tr v-if="!noSearch && searchAdvance">
                    <td class="before:hidden whitespace-nowrap"> <!-- OLD: v-if="checkable" -->
                        <div class="h-full flex justify-center items-center space-x-4">
                            <BaseButton color="info" :icon="mdiMagnify" small @click="listarData()" />
                            <BaseButton color="danger" :icon="mdiBroom" small @click="cleanAdvancedFilter()" />
                            <!-- <BaseButton color="danger" :icon="mdiBroom" small :inertiahref="route(ruta + '-list')" class="m-0" /> -->
                        </div>
                    </td>
                    <td v-if="showIndex"></td>
                    <td v-for="field in fields">
                        <div v-if="!field.nosearch && (field.type == 'boolean' || field.type == 'status' || field.type == 'foraign' || field.type == 'str2select')">
                            <VueSelect v-if="field.searchvueselect" class="w-full min-w-[150px] select-search-light" v-model="searchFieldCol[field.col]" :options="field.replacesearch" :get-option-label="(option) => `${option.label}`" placeholder="" @keyup.enter="listarData()" />
                            <select v-else class="w-full" v-model="searchFieldCol[field.col]">
                                <option value="" selected></option>
                                <option v-for="(f, index) in field.replace" :value="index">{{ f }}</option>

                            </select>

                        </div>
                        <div v-else-if="!field.nosearch && field.type == 'text'">
                            <input class="w-full" type="text" v-model="searchFieldCol[field.col]" @keyup.enter="listarData()">
                        </div>
                        <div v-else-if="!field.nosearch && field.type == 'number'">
                            <input class="w-full" type="number" v-model="searchFieldCol[field.col]">
                        </div>
                        <div v-else-if="!field.nosearch && field.type == 'date'" class="w-36">
                            <input type="date" v-model="searchFieldCol[field.col]" placeholder="De" class="w-full mb-2">
                            <input v-if="field.searchrange" type="date" v-model="searchFieldCol[field.col + '_rango']" placeholder="a" class="w-full">
                        </div>
                        <div v-else-if="!field.nosearch && field.type == 'month'">
                            <input class="w-full" type="month" v-model="searchFieldCol[field.col]">
                        </div>
                        <div v-else-if="!field.nosearch && field.type == 'year'">
                            <input class="w-full" type="year" v-model="searchFieldCol[field.col]">
                        </div>
                        <div v-else>
                            <span></span>
                        </div>
                    </td>
                    <!-- <td>
            <BaseButtons type="justify-start lg:justify-end" no-wrap>
                <BaseButton
                color="info"
                :icon="mdiMagnify"
                small
                @click="listarData()"
                />
                <BaseButton
                color="white"
                :icon="mdiCloseCircle"
                small
                :inertiahref="route(ruta+'-list')"
                />

              </BaseButtons>
              <div class="flex justify-center items-center">
                 <BaseButton color="info" :icon="mdiMagnify" small @click="listarData()" class="mr-3" />
                <BaseButton color="danger" :icon="mdiBroom" small @click="cleanAdvancedFilter()" class="m-0" />
                 <BaseButton color="danger" :icon="mdiBroom" small :inertiahref="route(ruta + '-list')" class="m-0" />
              </div>
            </td> -->
                </tr>
                <!-- Títulos -->
                <tr>
                    <!-- (checkable || optionsbutton) !noSearch && (checkable || searchAdvance) -->
                    <th v-if="(checkable || optionsbutton || searchAdvance)" class="h-full">
                        <!-- CORREGIR -->
                        <div class="flex justify-center items-center before:hidden whitespace-nowrap">
                            <div v-if="checkable" class="inline-block">
                                <label class="checkbox ">
                                    <input v-model="allCheckBox" type="checkbox" @change="changeAllCheckBox()" />
                                    <span class="check" />
                                </label>
                            </div>
                            <div v-if="searchAdvance">
                                <div v-if="(ruta == 'student' && !originId) || ruta == 'collaborator' || ruta == 'payementOrder' || ruta == 'cobranzas' || ruta == 'facture' || ruta == 'product'" class="relative m-0 ml-4">
                                    <!-- Dropdown toggle button -->
                                    <BaseButton :color="(showListColMenu ? 'success' : 'info')" :icon="(showListColMenu ? mdiCheckBold : mdiFormatListCheckbox)" small @click="updateUserParam(); showListColMenu = !showListColMenu" :inertiahref="(showListColMenu ? (ruta == 'student' ? route(ruta + '-list') : route('dashboard')) : '')" class="m-0" :title="(showListColMenu ? 'Guardar columnas seleccionadas' : 'Ver lista de columnas')" />
                                    <!-- Dropdown menu right o left apertura de lista -->
                                    <div v-show="showListColMenu" class="absolute left-0 py-2 mt-2 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 w-44 z-50 max-h-[300px] overflow-y-auto font-normal">
                                        <!-- buscar LRR <router-link to="/"
                    class="block px-4 py-2 text-sm hover:bg-gray-100 border-b border-b-gray-500">
                    <input
                      class="shadow appearance-none border rounded w-full py-2 px-3 placeholder-gray-500 text-gray-900 leading-tight focus:outline-none focus:shadow-outline"
                      type="text" placeholder="buscar">
                  </router-link> --> <!-- <option v-for="(option, index) in relojes" :value="index" :key="option">{{ option }}</option> -->
                                        <div v-for="param in userParam" class="block px-4 py-2 text-sm hover:bg-gray-100">
                                            <label class="checkbox">
                                                <input type="checkbox" v-model="formParam[param.col]" :checked="(param.check ? true : false)" />
                                                <span class="check" /> {{ param.label }}
                                            </label>
                                        </div>
                                        <!-- <router-link to="/" class="block px-4 py-2 text-sm hover:bg-gray-100">
                    Dropdown List 3
                  </router-link>
                  <router-link to="/" class="block px-4 py-2 text-sm hover:bg-gray-100">
                    Dropdown List 3
                  </router-link>
                  <router-link to="/" class="block px-4 py-2 text-sm hover:bg-gray-100">
                    Dropdown List 3
                  </router-link>
                  <router-link to="/" class="block px-4 py-2 text-sm hover:bg-gray-100">
                    Dropdown List 3
                  </router-link>
                  <router-link to="/" class="block px-4 py-2 text-sm hover:bg-gray-100">
                    Dropdown List 3
                  </router-link>
                  <router-link to="/" class="block px-4 py-2 text-sm hover:bg-gray-100">
                    Dropdown List 3
                  </router-link>
                  <router-link to="/" class="block px-4 py-2 text-sm hover:bg-gray-100">
                    Dropdown List 3
                  </router-link>
                  <router-link to="/" class="block px-4 py-2 text-sm hover:bg-gray-100">
                    Dropdown List 3
                  </router-link> -->

                                    </div>
                                </div>
                            </div>
                        </div>
                    </th>
                    <th v-if="showIndex">#</th>
                    <!-- <TableCheckboxCell
            v-if="checkable"
            v-model="allCheckBox"
            @checked="changeAllCheckBox()"
          /> -->
                    <th v-for="field in fields" @click="orderByCol(field.col)" :title="field.help">{{ field.name }}
                    </th>
                    <!-- Menú columnas personalizadas -->
                    <th v-if="!optionsbutton && !noSearch" class="flex justify-center items-center">
                        <!-- Sólo cobranzas -->
                        <div v-if="modulo == 'cobranzas'" class="relative m-0">
                            <!-- Dropdown toggle button -->
                            <BaseButton :color="(showListColMenu ? 'success' : 'info')" :icon="(showListColMenu ? mdiCheckBold : mdiFormatListCheckbox)" small @click="updateUserParam(); showListColMenu = !showListColMenu" :inertiahref="(showListColMenu ? (ruta == 'student' ? route(ruta + '-list') : route('dashboard')) : '')" class="m-0" :title="(showListColMenu ? 'Guardar columnas seleccionadas' : 'Ver lista de columnas')" />
                            <!-- Dropdown menu right o left apertura de lista -->
                            <div v-show="showListColMenu" class="absolute right-0 py-2 mt-2 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 w-44 z-50 max-h-[300px] overflow-y-auto font-normal">
                                <div v-for="param in userParam" class="block px-4 py-2 text-sm hover:bg-gray-100">
                                    <label class="checkbox">
                                        <input type="checkbox" v-model="formParam[param.col]" :checked="(param.check ? true : false)" />
                                        <span class="check" /> {{ param.label }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody :set="totales = { 'ttc': 0 }" class="text-sm">
                <!-- <tr v-for="client in itemsPaginated" :key="client.id"> -->
                <tr v-for="(client, index) in itemsPaginated" :key="index">
                    <!-- <TableCheckboxCell
              v-if="checkable"
              v-model="selectRows[index+1]"
            /> -->
                    <td v-if="(checkable || optionsbutton || searchAdvance)" class="h-full"><!-- !noSearch -->
                   
                        <div class="flex items-center space-x-4 w-full justify-between lg:justify-center">
                            <div v-if="checkable" class="inline-block">
                                <label class="checkbox">
                                    <input v-model="selectRows[index + 1]" type="checkbox" @change="countCheckedSingle()" />
                                    <span class="check" />
                                </label>
                            </div>
                            <!-- Si hay muchos botones se tiene la opción de lista Dropdown -->
                            <div v-if="optionsbutton">
                                <BreezeDropdown align="leftRight" class="border-0"> <!-- align="left" -->
                                    <template #trigger class="border-0">
                                        <BaseButton :icon="(mdiDotsVertical)" :color="(showListColMenu ? '' : 'btn-light')" class="icon-btn" />
                                    </template>

                                    <template #content class="mt-2">
                                        <BreezeDropdownLink v-if="visualable" @click="viewCard(client.id)">
                                            Ver Ficha
                                        </BreezeDropdownLink>

                                    </template>
                                </BreezeDropdown>
                            </div>
                            <!-- {{ index + 1 }} {{ selectRows[index+1] }} -->
                        </div>
                    </td>
                    <td v-if="showIndex" data-label="#">{{ index + 1 }}</td>
                    <!-- <TableCheckboxCell
            v-if="checkable"
            @checked="checked($event, client)"
            /> -->
                    <!--<td class="border-b-0 lg:w-6 before:hidden">
            <UserAvatar
                :username="client.ref"
                class="w-24 h-24 mx-auto lg:w-6 lg:h-6"
            />
            </td>-->
                    <!-- Columnas de lista -->
                    <td v-for="field in fields" :data-label="field.name">
                        <div v-if="field.type == 'boolean'">
                            <!--<small v-if = "client[field.col]" class="inline-flex items-center capitalize leading-none text-sm border rounded-md py-1 px-2  bg-emerald-500 border-emerald-500 text-white last:mr-0">
                    <span>Activo</span>
                  </small>
                  <small v-else class="inline-flex items-center capitalize leading-none text-sm border rounded-md py-1 px-2  bg-red-500 border-red-500 text-white last:mr-0">
                    <span>Inactivo</span>
                  </small>-->

                            <!-- Si el valor es mayor a cero entonces mostrar el campo reemplazado por texto -->
                            <small v-if="client[field.col] == '1'" class="inline-flex items-center capitalize leading-none text-sm border rounded-md py-1 px-2  bg-emerald-500 border-emerald-500 text-white last:mr-0">
                                {{ field.replace[client[field.col]] }}
                            </small>
                            <small v-else-if="client[field.col] == '2'" class="inline-flex items-center capitalize leading-none text-sm border rounded-md py-1 px-2  transition-colors focus:ring duration-150 border-yellow-600 dark:border-yellow-500 ring-yellow-300 dark:ring-yellow-700 bg-yellow-600 dark:bg-yellow-500 text-white last:mr-0">
                                {{ field.replace[client[field.col]] }}
                            </small>
                            <small v-else-if="client[field.col] == '-1'" class="inline-flex items-center capitalize leading-none text-sm border rounded-md py-1 px-2  border-gray-200  bg-white text-black last:mr-0">
                                {{ field.replace[client[field.col]] }}
                            </small>
                            <small v-else class="inline-flex items-center capitalize leading-none text-sm border rounded-md py-1 px-2  transition-colors focus:ring duration-150 border-red-600 dark:border-red-500 ring-red-300 dark:ring-red-700 bg-red-600 dark:bg-red-500 text-white last:mr-0">
                                {{ field.replace[client[field.col]] }}
                            </small>
                        </div>
                        <div v-else-if="field.type == 'status'"><!-- UPD 231120 -->
                            <template v-if="modulo == 'facture'">
                                <small v-if="client[field.col] == '3' || client[field.col] == '4'" class="inline-flex items-center capitalize leading-none text-sm border rounded-md py-1 px-2  transition-colors focus:ring duration-150 border-red-600 dark:border-red-500 ring-red-300 dark:ring-red-700 bg-red-600 dark:bg-red-500 text-white last:mr-0">
                                    {{ field.replace[client[field.col]] }}
                                </small>
                                <small v-else-if="client[field.col] == '2'" class="inline-flex items-center capitalize leading-none text-sm border rounded-md py-1 px-2  bg-emerald-500 border-emerald-500 text-white last:mr-0">
                                    {{ field.replace[client[field.col]] }}
                                </small>
                                <small v-else-if="client[field.col] == '1'" class="inline-flex items-center capitalize leading-none text-sm border rounded-md py-1 px-2  bg-white border-emerald-500 text-black last:mr-0">
                                    {{ field.replace[client[field.col]] }}
                                </small>
                                <small v-else class="inline-flex items-center capitalize leading-none text-sm border rounded-md py-1 px-2  transition-colors focus:ring duration-150 border-yellow-600 dark:border-yellow-500 ring-yellow-300 dark:ring-yellow-700 bg-yellow-600 dark:bg-yellow-500 text-white last:mr-0">
                                    {{ field.replace[client[field.col]] }}
                                </small>

                            </template>
                            <template v-else>
                                <small v-if="client[field.col] == '2'" class="inline-flex items-center capitalize leading-none text-sm border rounded-md py-1 px-2  bg-emerald-500 border-emerald-500 text-white last:mr-0">
                                    {{ field.replace[client[field.col]] }}
                                </small>
                                <small v-else-if="client[field.col] == '1'" class="inline-flex items-center capitalize leading-none text-sm border rounded-md py-1 px-2  transition-colors focus:ring duration-150 border-yellow-600 dark:border-yellow-500 ring-yellow-300 dark:ring-yellow-700 bg-yellow-600 dark:bg-yellow-500 text-white last:mr-0">
                                    {{ field.replace[client[field.col]] }}
                                </small>
                                <small v-else class="inline-flex items-center capitalize leading-none text-sm border rounded-md py-1 px-2  transition-colors focus:ring duration-150 border-red-600 dark:border-red-500 ring-red-300 dark:ring-red-700 bg-red-600 dark:bg-red-500 text-white last:mr-0">
                                    {{ field.replace[client[field.col]] }}
                                </small>
                            </template>
                        </div>
                        <div v-else-if="field.type == 'foraign'">
                            <span v-if="client[field.col]">
                                <span v-if="modulo == 'calification' && originType == 'classroom' && parseInt(field.replace[client[field.col]]) < 11" class="text-red-600">{{ field.replace[client[field.col]] }}</span>
                                <!-- Caso Cobranzas objeto -->
                                <!-- <span v-else-if="(modulo=='cobranzas' && field.col == 'id_student_total_deuda')" :set="deudaTot = field.replace[client[field.col]]">
                      <small class="text-black-600">{{ deudaTot.total_actual }}</small>
                    </span> -->
                                <span v-else>{{ field.replace[client[field.col]] }}</span>
                            </span>
                            <div v-else>
                                {{ field.replace[client[field.col]] }}
                            </div>

                        </div>
                        <div v-else-if="field.type == 'replacefromid'">
                            {{ valueReplace[client.id] }}
                        </div>
                        <div v-else-if="field.type == 'date'">
                            {{ formatDate(client[field.col]) }}
                        </div>
                        <div v-else-if="field.type == 'datetime'">
                            {{ formatDateTime(client[field.col]) }}
                        </div>
                        <div v-else-if="field.type == 'year'">
                            {{ formatDate(client[field.col], 'Y') }}
                        </div>
                        <!-- Mostrar con asterisco los retirados -->
                        <div v-else-if="(modulo == 'cobranzas' && field.col == 'apellidos' && client['status_student'] == 0)">
                            {{ client[field.col] }} <small class="text-red-600">Ret.</small>

                        </div>
                        <!-- Whatsapp -->
                        <div v-else-if="field.type == 'mobile_phone'" class="flex items-center">
                            {{ client[field.col] }}
                            <div v-if="client[field.col]" class="h-[34px]">
                                <a :href="'https://wa.me/51' + (client[field.col] ?? '') + '?text=Hola'" target="_blank" class="inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-green-500 ring-green-300 bg-green-500  text-white hover:bg-green-600 hover:border-green-600 p-1 ml-2">
                                    <BaseIcon :path="mdiWhatsapp" :size="32" class="h-5" />
                                </a>
                            </div>
                        </div>
                        <div v-else-if="field.linkobject">
                            <Link v-if="modulo == 'payementOrder' || modulo == 'cobranzas' || modulo == 'facture'" :href="field.linkobject.replace('__ID_STUDENT__', client.id_student)" class="text-blue-600 hover:text-blue-800 hover:font-semibold transition-all ease-in-out delay-150 duration-150">{{ client[field.col] }}</Link>
                            <Link v-else :href="field.linkobject.replace('__ID__', client.id)" class="text-blue-600 hover:text-blue-800 hover:font-semibold transition-all ease-in-out delay-150 duration-150">{{ client[field.col] }}</Link>
                        </div>
                        <div v-else>
                            {{ client[field.col] }}

                        </div>
                        <div class="hidden" v-if="showTotales && field.type == 'number' && field.col == 'total_ttc'">
                            {{ totales.ttc+=parseFloat(client[field.col]) }}
                        </div>
                    </td>
                    <!--<td data-label="Progress" class="lg:w-32">
            <progress
                class="flex w-2/5 self-center lg:w-full"
                max="100"
                :value="client.progress"
            >
                {{ client.progress }}
            </progress>
            </td>
            -->
                    <!--<td data-label="Creado" class="lg:w-1 whitespace-nowrap">
            <small
                class="text-gray-500 dark:text-slate-400"
                :title="client.created"
                >{{ client.created_at }}</small
            >
            </td>-->
                    <td v-if="!optionsbutton" class="before:hidden lg:w-1 whitespace-nowrap">
                        <BaseButtons type="justify-center w-full" no-wrap>
                            <BaseButton v-if="visualable" color="info" :icon="mdiEye" small @click="viewCard(client.id)" />
                            <!--v-if="visualable"-->

                            <!--class="inline-flex justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border cursor-pointer rounded border-yellow-600 dark:border-yellow-500 ring-yellow-300 dark:ring-yellow-700 bg-yellow-600 dark:bg-yellow-500 text-white hover:bg-yellow-700 hover:border-yellow-700 hover:dark:bg-yellow-600 hover:dark:border-yellow-600 p-1 mr-3 last:mr-0 mb-3"
                  -->
                            <!--class="inline-flex justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border cursor-pointer rounded border-emerald-600 dark:border-emerald-500 ring-emerald-300 dark:ring-emerald-700 bg-emerald-600 dark:bg-emerald-500 text-white hover:bg-emerald-700 hover:border-emerald-700 hover:dark:bg-emerald-600 hover:dark:border-emerald-600 p-1 mr-3 last:mr-0 mb-3"-->

                            <BaseButton v-if="isCanActive && client.status == 0" color="success" :icon="mdiCheckCircle" small @click="isModalActive = true" />
                            <BaseButton v-if="isCanActive && client.status" color="danger" :icon="mdiCloseCircle" small @click="isModalDangerActive = true" class="inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-red-600 dark:border-red-500 ring-red-300 dark:ring-red-700 bg-red-600 dark:bg-red-500 text-white hover:bg-red-700 hover:border-red-700 hover:dark:bg-red-600 hover:dark:border-red-600 p-1 mr-3 last:mr-0 mb-3" />

                            <!-- Show in file list  :href="route('file-open', {'srctype': client.src_object_type, 'srcid': (client.src_object_id ? client.src_object_id : 0), 'filename': client.filename })" -->
                            <!-- <BaseButton
                    v-if="ruta == 'file' && originType == 'student'"
                    color="info"
                    :icon="mdiEmailArrowRight"
                    label = 'Enviar Notificación'
                    small
                    @click="sendNotification()"
                  /> -->
                            <BaseButton v-if="ruta == 'file' && canView" color="info" :icon="mdiEye" small @click="(isModalFullActive = true, modalFullSrc = '/documents/' + client.filepath + '/' + client.filename)" class="hidden lg:grid" />
                            <BaseButton v-if="ruta == 'file' && canDownload" color="info" :icon="mdiDownload" small :href="route((client.origin_id2 && client.origin_id2 > 0 ? 'file-download2' : (client.origin_id && client.origin_id > 0 ? 'file-download' : 'file-download')), { 'srctype': client.src_object_type, 'srcid': (client.src_object_id ? client.src_object_id : 0), 'filename': client.filename, 'srcid2': (client.origin_id2 ? client.origin_id2 : 0) })" target="_blank" @click="" />

                            <BaseButton v-if="updateable" color="warning" :icon="mdiPencil" small :inertiahref="route(ruta + '-edit', { 'id': client.id })" />

                            <BaseButton v-if="deleteable" color="danger" :icon="mdiTrashCan" small @click="initModal(client.id, 'eliminar')" />

                            <!-- Caso libreta de notas -->
                            <BaseButton v-if="modulo == 'estudiante' && printLine" color="info" :icon="mdiGraphql" label="gráfico" small @click="showPromedios(client.id)" />
                            <BaseButton v-if="modulo == 'estudiante' && printLine" color="info" :icon="mdiPrinter" :label="labelprint1" small :href="'/calification/libreta' + '?id=' + client.id" target="_blank" />

                            <!-- Caso Admisión Puntaje-->
                            <BaseButton v-if="modulo == 'admisionpuntaje' && printLine && client.resultado == 1 && canPrint" color="info" :icon="mdiPrinter" :label="labelprint1" small :href="'/admisionpuntaje/diploma' + '?id=' + client.id + '&puesto=' + (valueReplace[client.id])" target="_blank" />

                            <!-- Caso cobranzas -->
                            <input v-if="modulo == 'cobranzas'" type="hidden" :set="infoContact = { 'contacto': '', 'totales': '' }">
                            <input v-if="modulo == 'cobranzas'" v-for="field in fields" type="hidden" :set="(field.col == 'id_student_contact' ? infoContact.contacto = String(field.replace[client.id_student_contact]).split(', ') : '')">
                            <input v-if="modulo == 'cobranzas'" v-for="field in fields" type="hidden" :set="(field.col == 'id_student_total_deuda' ? infoContact.totales = String(field.replace[client.id_student_total_deuda]).split(' | ') : '')">

                            <BaseButton v-if="modulo == 'cobranzas'" color="info" :icon="mdiPhoneOutgoing" :href="'tel:' + (infoContact.contacto[2] ?? '')" target="_blank" />

                            <input v-if="modulo == 'cobranzas' && confGlobal.value.FINANCIERA_USE_MORA == 1 && confGlobal.value.FINANCIERA_USE_ORDEN_PAGO_OTROS == 1" type="hidden" :set="msgReplaceObj = { '__APODERADO_NOMBRE__': (infoContact.contacto[1] ?? ''), '__REF_DEUDAS__': infoContact.totales[0], '__TOT_PENSION__': infoContact.totales[1], '__TOT_MORA__': infoContact.totales[2], '__TOT_OTROS__': infoContact.totales[3], '__TOT_ACTUAL__': infoContact.totales[4] }">
                            <input v-else-if="modulo == 'cobranzas' && confGlobal.value.FINANCIERA_USE_ORDEN_PAGO_OTROS == 1" type="hidden" :set="msgReplaceObj = { '__APODERADO_NOMBRE__': (infoContact.contacto[1] ?? ''), '__REF_DEUDAS__': infoContact.totales[0], '__TOT_PENSION__': infoContact.totales[1], '__TOT_OTROS__': infoContact.totales[2], '__TOT_ACTUAL__': infoContact.totales[3] }">
                            <input v-else-if="modulo == 'cobranzas'" type="hidden" :set="msgReplaceObj = { '__APODERADO_NOMBRE__': (infoContact.contacto[1] ?? ''), '__REF_DEUDAS__': infoContact.totales[0], '__TOT_ACTUAL__': infoContact.totales[1] }">

                            <!-- NO botón  small -->
                            <BaseButton v-if="modulo == 'cobranzas'" color="green" :icon="mdiWhatsapp" class="bg-green-500 text-white" :href="'https://wa.me/51' + (infoContact.contacto[2] ?? '') + '?text=' + (infoContact.contacto[1] && confGlobal.value.COBRANZA_MENSAJE_ENVIO_APODERADO ? encodeURI(confGlobal.value.COBRANZA_MENSAJE_ENVIO_APODERADO.replace(/\b(?:__APODERADO_NOMBRE__|__REF_DEUDAS__|__TOT_PENSION__|__TOT_MORA__|__TOT_OTROS__|__TOT_ACTUAL__)\b/gi, matched => msgReplaceObj[matched])) : '')" target="_blank" />

                            <BaseButton v-if="modulo == 'cobranzas'" color="info" :icon="mdiEmailArrowRight" :href="'mailto:' + (infoContact.contacto[3] ?? '') + '?subject=' + confGlobal.value.COBRANZA_ASUNTO_ENVIO_APODERADO + '&body=' + (infoContact.contacto[1] && confGlobal.value.COBRANZA_MENSAJE_ENVIO_APODERADO ? confGlobal.value.COBRANZA_MENSAJE_ENVIO_APODERADO.replace(/\b(?:__APODERADO_NOMBRE__|__REF_DEUDAS__|__TOT_PENSION__|__TOT_MORA__|__TOT_OTROS__|__TOT_ACTUAL__)\b/gi, matched => msgReplaceObj[matched]) : '')" target="_blank" />

                            <!-- <BaseButton
                  v-if="modulo=='cobranzas'"
                  color="success"
                  :icon="mdiCashPlus"
      
                  :href="'mailto:'+(infoContact.contacto[3] ?? '')+'?subject='+confGlobal.value.COBRANZA_ASUNTO_ENVIO_APODERADO+'&body='+(infoContact.contacto[1] && confGlobal.value.COBRANZA_MENSAJE_ENVIO_APODERADO ? confGlobal.value.COBRANZA_MENSAJE_ENVIO_APODERADO.replace(/\b(?:__APODERADO_NOMBRE__|__REF_DEUDAS__|__TOT_PENSION__|__TOT_MORA__|__TOT_OTROS__|__TOT_ACTUAL__)\b/gi, matched => msgReplaceObj[matched]) : '')"
                  target="_blank"
                  /> -->

                            <!-- Caso Facturación :icon="mdiFilePdfBox" -->
                            <BaseButton v-if="ruta == 'facture' && client['estadosunat'] >= 1" color="danger" label="PDF" small :href="client['enlace'] + '.pdf'" target="_blank" />
                            <input v-if="modulo == 'facture'" type="hidden" :set="infoContact = { 'contacto': '', 'totales': '' }">
                            <input v-if="modulo == 'facture'" v-for="field in fields" type="hidden" :set="(field.col == 'id_student_contact' ? infoContact.contacto = String(field.replace[client.id_student_contact]).split(', ') : '')">
                            <input v-if="modulo == 'facture'" type="hidden" :set="msgReplaceObj = { '__APODERADO_NOMBRE__': (infoContact.contacto[1] ?? ''), '__ENLACE_CPE__': client['enlace'] + '.pdf' }">

                            <BaseButton v-if="modulo == 'facture' && infoContact.contacto && client['estadosunat'] >= 1" color="green" :icon="mdiWhatsapp" class="bg-green-500 text-white" :href="'https://wa.me/51' + (infoContact.contacto[2] ?? '') + '?text=' + (infoContact.contacto[1] && confGlobal.value.FACTURA_MENSAJE_ENVIO_APODERADO ? encodeURI(confGlobal.value.FACTURA_MENSAJE_ENVIO_APODERADO.replace(/\b(?:__APODERADO_NOMBRE__|__ENLACE_CPE__)\b/gi, matched => msgReplaceObj[matched])) : '')" target="_blank" />

                        </BaseButtons>
                    </td>
                </tr>
                <tr v-if="showTotales">
                    <td v-if="checkable"></td>
                    <td v-if="showIndex">#</td>
                    <td v-for="field in fields" :data-label="field.name">
                        <div v-if="field.type == 'number' && field.col == 'total_ttc'">
                            {{ totales.ttc.toFixed(2) }}
                        </div>
                        <div v-else>
                        </div>
                    </td>
                    <td />
                </tr>
            </tbody>
        </table>
        <div v-if="!noPaginate" class="p-3 lg:px-6 border-t border-gray-100 dark:border-slate-800">
            <BaseLevel>
                <!--<BaseButtons>
              <template v-if="pagesList.length < 11">
                <BaseButton
                v-for="page in pagesList"
                :key="page"
                :active="page === currentPage"
                :label="page + 1"
                :color="page === currentPage ? 'lightDark' : 'whiteDark'"
                small
                @click="currentPage = page"
                />
              </template>
              <template v-else>
                <template v-for="page in pagesList" :key="page">
                  <BaseButton
                  v-if="page < 10"
                  :active="page === currentPage"
                  :label="page + 1"
                  :color="page === currentPage ? 'lightDark' : 'whiteDark'"
                  small
                  @click="currentPage = page"
                  />
                  <BaseButton
                  v-if="page == 11 && isShowAllPages == false"
                  :label="'Ver todas las páginas'"
                  :color="page === currentPage ? 'lightDark' : 'whiteDark'"
                  small
                  @click="isShowAllPages=true"
                  />
                  <BaseButton
                  v-if="isShowAllPages && page > 9"
                  :active="page === currentPage"
                  :label="page + 1"
                  :color="page === currentPage ? 'lightDark' : 'whiteDark'"
                  small
                  @click="currentPage = page"
                  />
                </template>
              </template>
          </BaseButtons>-->

                <small>Página {{ currentPageHuman }} de {{ numPages }}</small>
            </BaseLevel>
        </div>
    </div>
</template>